import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Froalaeditor from "froala-editor";
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/js/plugins.pkgd.min.js";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";
import uuid from "react-uuid";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import "./FroalaEditorStyles.scss";
import BulbIcon from "../../../assets/images/bulbIcon.png";
import { decodeEntities } from "../../utils/services";
import EditOptionsDialog from "./EditOptionsDialog";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import toast from "react-hot-toast";
import CopySummaryModal from "../TemplateUtils/CopySummaryModal";
import { addGlobalList, editGlobalList, getGlobalListById } from "../../store/action";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@mui/material";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import TextFieldsIcon from '@mui/icons-material/TextFields';

const FroalaEditorComponent = (props) => {
  const {
    id,
    copy,
    type,
    showAI,
    editor,
    onChange,
    dialogRef,
    setCopied,
    editorData,
    showAIModal,
    commentData,
    froalaConfig,
    setShowAIModal,
    setEditorContent,
    setIsButtonAdded,
    handleDropdownList,
    onFocusEditor,
    commentOptionList,
    setCommentOptionList,
    setActiveEditorId,
    onBlur,
    handleChangeDropdown,
    AllCategoryList,
    filterTagList,
    newOpen,
    setIsFocused,
    setHasChanges,
    setCommentText,
    setCommentSummary,
    handleIntroSave,
    hasChanges,

  } = props;

  const initialDropdownList = id === "introTextTE" ? commentData?.introductory_text_dropdowns : id === "commentSummary" ? commentData?.summary_comment_dropdowns : commentData?.comment_dropdowns;
  const [state, setState] = useState({
    open: false,
    openHelp: false,
    editedOption: null,
    dialogOptionList: [],
    isdropdownAdded: true,
    selectedDropdown: null,
    openRemoveDropdown: false,
    dropdownList: Array.isArray(initialDropdownList) ? initialDropdownList : [],
    selectedInput: null,
    summaryOptionList: [],
    isFocused: false,
    name: "", tags: [], description: "", saveToGlobalLists: false, listId: null, isDialogLoading: false
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentInputId, setCurrentInputId] = useState(null);
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const dropdownOptionListRef = useRef([]);
  const storeData = useSelector((state) => state.commentLibrary);
  const location = useLocation();
  const dispatch = useDispatch();
  const { openHelp, dropdownList, selectedDropdown, dialogOptionList, openRemoveDropdown, summaryOptionList, isFocused, open, name, tags, description, saveToGlobalLists, listId, listGuid } = state;
  const templateData = useSelector((state) => state.templates).templateData;
  const isNarrativeTemplate = templateData?.template?.is_narrative_template;
  const savedSelectionRef = useRef(null);
  const mouseDownRangeRef = useRef(null);
  const pendingCursorOffsetRef = useRef(null);
  const savedClickRangeRef = useRef(null);
  const savedClickCoordsRef = useRef(null);
  const editorDataRef = useRef(editorData);
  const anchorElRef = useRef(null);


  const savedRangeRef = useRef(null);
  const lastFocusedDropdownRef = useRef(null);
  const lastFocusedDynamicWrapperRef = useRef(null);
  const dynamicInputListenersRef = useRef(new Map());
  const dynamicInputObserverRef = useRef(null);
  const dynamicInputObserverRootRef = useRef(null);
  const suppressBlurPersistRef = useRef(false);


  const detachDynamicInputListeners = useCallback((inputId) => {
      const entry = dynamicInputListenersRef.current.get(inputId);
      if (!entry) return;
      entry.inputEl.removeEventListener("change", entry.handleChange);
      entry.inputEl.removeEventListener("input", entry.handleInput);
      entry.inputEl.removeEventListener("keydown", entry.handleKeydown, true);
      if (entry.handleFocus) entry.inputEl.removeEventListener("focus", entry.handleFocus);
      if (entry.handleBlur) entry.inputEl.removeEventListener("blur", entry.handleBlur);
      dynamicInputListenersRef.current.delete(inputId);
  }, []);

  const removeEmptyDynamicInputWrappers = useCallback((root) => {
    const editorRoot = root || editor.current?.editor?.$el?.get(0);
    if (!editorRoot) return false;
    const wrappers = editorRoot.querySelectorAll(".froala-dynamic-input-wrapper")||
    editorRoot.querySelectorAll('span[contenteditable="false"]');;
    let removed = false;
    wrappers.forEach((wrapper) => {
      if (wrapper.querySelector("input")) return;
      wrapper.remove();
      removed = true;
    });
    return removed;
  }, [editor]);

  const cleanupRemovedDynamicInputs = useCallback((mutations) => {
    const hasRemovals = mutations.some((m) => m.removedNodes.length > 0);
    if (!hasRemovals) return;
    if (dynamicInputListenersRef.current.size) {
      [...dynamicInputListenersRef.current.keys()].forEach((inputId) => {
        const entry = dynamicInputListenersRef.current.get(inputId);
        if (entry && !document.contains(entry.inputEl)) detachDynamicInputListeners(inputId);
      });
    }
    removeEmptyDynamicInputWrappers(dynamicInputObserverRootRef.current);
  }, [detachDynamicInputListeners, removeEmptyDynamicInputWrappers]);

  const ensureDynamicInputObserver = useCallback((editorRoot) => {
    if (!editorRoot) return;
    if (dynamicInputObserverRef.current && dynamicInputObserverRootRef.current === editorRoot) return;
    dynamicInputObserverRef.current?.disconnect();
    dynamicInputObserverRef.current = new MutationObserver(cleanupRemovedDynamicInputs);
    dynamicInputObserverRef.current.observe(editorRoot, { childList: true, subtree: true });
    dynamicInputObserverRootRef.current = editorRoot;
  }, [cleanupRemovedDynamicInputs]);


  const persistDynamicInputValues = useCallback((editorInstance, sourceDropdownList) => {
    const editorEl = editorInstance?.$el?.get(0);
    // Coerced with asArrayOrNull (defined below) before spreading - commentData's dropdown
    // fields, and sourceDropdownList itself, can come back as a non-array from the API (e.g.
    // {} when a comment has no dropdowns yet). Spreading a non-array throws "is not iterable".
    const baseList = Array.isArray(sourceDropdownList)
      ? sourceDropdownList.map((d) => ({ ...d }))
      : [...(asArrayOrNull(editorDataRef.current?.dropdownList) || asArrayOrNull(editorData?.dropdownList) || asArrayOrNull(dropdownList) || [])];

    if (!editorEl) return baseList;

    editorEl.querySelectorAll(".froala-dynamic-input-wrapper input, input.froala-dropdown-input").forEach((input) => {
      const val = (input.value ?? "").replace(/"/g, "&quot;").trim();
      input.setAttribute("value", val);
      input.setAttribute("title", val);

      if (input.classList.contains("froala-dropdown-input")) {
        const dropdownUuid = input.id?.replace(/^dropdown_/, "") ?? "";
        const idx = baseList.findIndex((d) => d.dropdown_uuid === dropdownUuid);
        if (idx !== -1) {
          baseList[idx] = { ...baseList[idx], selected_value: val };
        }
      }
    });

    return baseList;
  }, [dropdownList, editorData]);

  const asArrayOrNull = (value) => (Array.isArray(value) ? value : null);

  const getDropdownListSource = useCallback(() => {
    if (id === "commentSummary") {
      return (
        asArrayOrNull(editorDataRef.current?.dropdownList) ||
        asArrayOrNull(editorData?.dropdownList) ||
        (dropdownList?.length ? dropdownList : null) ||
        asArrayOrNull(commentData?.summary_comment_dropdowns) ||
        []
      );
    }
    if (id === "commentText" || id === "nonNarrativeComment") {
      return (
        asArrayOrNull(editorDataRef.current?.dropdownList) ||
        asArrayOrNull(editorData?.dropdownList) ||
        (dropdownList?.length ? dropdownList : null) ||
        asArrayOrNull(commentData?.comment_dropdowns) ||
        []
      );
    }
    if (id === "introTextTE") {
      return (
        asArrayOrNull(editorDataRef.current?.dropdownList) ||
        asArrayOrNull(editorData?.dropdownList) ||
        (dropdownList?.length ? dropdownList : null) ||
        asArrayOrNull(commentData?.introductory_text_dropdowns) ||
        []
      );
    }
    return (
      asArrayOrNull(editorDataRef.current?.dropdownList) ||
      asArrayOrNull(editorData?.dropdownList) ||
      (dropdownList?.length ? dropdownList : null) ||
      []
    );
  }, [commentData, dropdownList, editorData, id]);

  const syncEditorStateWithDropdowns = useCallback(
    (innerHTML, updatedDropdownList) => {
      const list = (updatedDropdownList ?? getDropdownListSource()).map((d) => ({ ...d }));
      setState((prev) => ({ ...prev, dropdownList: list }));

      if (!setEditorContent) return;

      if (id === "introTextTE") {
        setEditorContent((prev) => ({ ...prev, innerHTML, dropdownList: list }));
        handleDropdownList?.(id, list);
        return;
      }
      if (id === "commentText") {
        setEditorContent((prev) => ({
          ...prev,
          commentText: {
            ...(prev.commentText || editorDataRef.current || editorData),
            innerHTML,
            dropdownList: list,
          },
          commentDropdownList: list,
        }));
        handleDropdownList?.(id, list);
        return;
      }
      if (id === "commentSummary") {
        setEditorContent((prev) => ({
          ...prev,
          commentSummary: {
            ...(prev.commentSummary || editorDataRef.current || editorData),
            innerHTML,
            dropdownList: list,
          },
          summaryDropdownList: list,
        }));
        handleDropdownList?.(id, list);
        return;
      }
      if (id === "nonNarrativeComment") {
        setEditorContent((prev) => ({ ...prev, innerHTML, dropdownList: list }));
      }
    },
    [getDropdownListSource, handleDropdownList, id, setEditorContent]
  );

  const syncChangedDropdownsOnBlur = useCallback((content, updatedDropdownList) => {
    if (id !== "introTextTE" || !onBlur || !updatedDropdownList?.length) return;
    const originalList = editorDataRef.current?.dropdownList || editorData?.dropdownList || [];
    updatedDropdownList.forEach((dropdown) => {
      const original = originalList.find((d) => d.dropdown_uuid === dropdown.dropdown_uuid);
      const newVal = (dropdown.selected_value ?? "").trim();
      const oldVal = (original?.selected_value ?? "").trim();
      if (newVal !== oldVal) {
        onBlur(id, content, dropdown, "edit");
      }
    });
  }, [editorData, id, onBlur]);

   const registerDynamicInputListeners = useCallback((inputEl, inputId, handleKeydown, handleChange) => {
    detachDynamicInputListeners(inputId);
    const handleFocus = () => {
      lastFocusedDynamicWrapperRef.current = inputEl.closest(".froala-dynamic-input-wrapper");
    };
    const handleInput = () => {
      const val = inputEl.value ?? "";
      inputEl.setAttribute("value", val);
      inputEl.setAttribute("title", val);
    };
    const handleBlur = (event) => {
      handleInput();
      if (!event.relatedTarget?.id?.startsWith("add-input")) {
        lastFocusedDynamicWrapperRef.current = null;
      }
    };
    dynamicInputListenersRef.current.set(inputId, {
      inputEl, handleChange, handleKeydown, handleFocus, handleBlur, handleInput,
    });
    inputEl.addEventListener("change", handleChange);
    inputEl.addEventListener("input", handleInput);
    inputEl.addEventListener("keydown", handleKeydown, true);
    inputEl.addEventListener("focus", handleFocus);
    inputEl.addEventListener("blur", handleBlur);
  }, [detachDynamicInputListeners]);

 

  const placeCaretInEditorAt = useCallback((anchorNode, parentNode) => {
    const activeEditor = editor.current?.editor;
    if (!activeEditor) return;
    try { activeEditor.events.focus(); } catch (err) {}
    const sel = window.getSelection();
    if (!sel) return;
    const newRange = document.createRange();
    if (anchorNode && document.contains(anchorNode)) {
      if (anchorNode.nodeType === Node.TEXT_NODE) {
        newRange.setStart(anchorNode, anchorNode.textContent.length);
      } else {
        newRange.setStartAfter(anchorNode);
      }
    } else if (parentNode && document.contains(parentNode)) {
      newRange.setStart(parentNode, 0);
    } else {
      return;
    }
    newRange.collapse(true);
    sel.removeAllRanges();
    sel.addRange(newRange);
    savedRangeRef.current = newRange.cloneRange();
  }, [editor]);

  const isEmptyParagraph = (node) => {
    if (!node || node.tagName !== "P") return false;
    return !node.innerHTML.replace(/&nbsp;|<br\s*\/?>/gi, "").trim();
  };

  const paragraphOnlyContainsWrapper = (paragraph) => {
    if (!paragraph || paragraph.tagName !== "P") return false;
    const clone = paragraph.cloneNode(true);
    clone.querySelectorAll(".froala-dynamic-input-wrapper").forEach((node) => node.remove());
    return !clone.innerHTML.replace(/&nbsp;|<br\s*\/?>/gi, "").trim();
  };

  const getListItemTargetParagraph = (listItem, range = null) => {
    if (!listItem) return null;

    if (range) {
      const rangeNode =
        range.startContainer.nodeType === Node.ELEMENT_NODE
          ? range.startContainer
          : range.startContainer.parentElement;
      const paragraphFromRange = rangeNode?.closest?.("p");
      if (paragraphFromRange && listItem.contains(paragraphFromRange)) {
        return paragraphFromRange;
      }
    }

    const paragraphs = [...listItem.children].filter((child) => child.tagName === "P");
    const contentParagraph = paragraphs.find((paragraph) => !isEmptyParagraph(paragraph));
    if (contentParagraph) return contentParagraph;

    const looseInlineNodes = [...listItem.childNodes].filter(
      (node) =>
        node.nodeName !== "UL" &&
        node.nodeName !== "OL" &&
        !(
          node.nodeType === Node.ELEMENT_NODE &&
          node.classList?.contains("froala-dynamic-input-wrapper")
        ) &&
        (node.nodeType === Node.TEXT_NODE
          ? node.textContent.replace(/\u00A0/g, " ").trim()
          : node.tagName !== "P")
    );

    if (looseInlineNodes.length) {
      const paragraph = document.createElement("p");
      const insertBefore = listItem.querySelector("ul, ol");
      if (insertBefore) {
        listItem.insertBefore(paragraph, insertBefore);
      } else {
        listItem.appendChild(paragraph);
      }
      looseInlineNodes.forEach((node) => paragraph.appendChild(node));
      return paragraph;
    }

    if (paragraphs.length) return paragraphs[paragraphs.length - 1];

    const paragraph = document.createElement("p");
    const insertBefore = listItem.querySelector("ul, ol");
    if (insertBefore) {
      listItem.insertBefore(paragraph, insertBefore);
    } else {
      listItem.appendChild(paragraph);
    }
    return paragraph;
  };

  const resolveListItemForInputInsert = (editorRoot, range) => {
    if (!editorRoot || !range) return null;

    const rangeNode =
      range.startContainer.nodeType === Node.ELEMENT_NODE
        ? range.startContainer
        : range.startContainer.parentElement;

    let listItem = rangeNode?.closest?.("li");
    if (listItem && editorRoot.contains(listItem)) return listItem;

    if (rangeNode?.tagName === "UL" || rangeNode?.tagName === "OL") {
      listItem =
        rangeNode.querySelector("li:last-child") ||
        rangeNode.querySelector("li");
      if (listItem && editorRoot.contains(listItem)) return listItem;
    }

    const listItemFromListElement = (listElement) => {
      if (!listElement?.querySelector) return null;
      if (listElement.tagName === "LI") return listElement;
      return (
        listElement.querySelector("li:last-child") ||
        listElement.querySelector("li")
      );
    };

    if (range.startContainer === editorRoot) {
      const { startOffset } = range;
      const nodeAfter = editorRoot.childNodes[startOffset];
      const nodeBefore = startOffset > 0 ? editorRoot.childNodes[startOffset - 1] : null;
      listItem =
        listItemFromListElement(nodeAfter) ||
        listItemFromListElement(nodeBefore);
      if (listItem && editorRoot.contains(listItem)) return listItem;
    } else if (rangeNode?.parentElement === editorRoot) {
      listItem =
        listItemFromListElement(rangeNode.nextElementSibling) ||
        listItemFromListElement(rangeNode.previousElementSibling);
      if (listItem && editorRoot.contains(listItem)) return listItem;
    }

    return null;
  };

  const moveWrapperIntoListItem = (wrapper, listItem) => {
    if (!wrapper || !listItem || listItem.contains(wrapper)) return;

    const trailingSep =
      wrapper.nextSibling?.nodeType === Node.TEXT_NODE &&
      /^[\s\u00A0]*$/.test(wrapper.nextSibling.textContent)
        ? wrapper.nextSibling
        : null;
    const sourceParent = wrapper.parentElement;
    const targetParagraph = getListItemTargetParagraph(listItem);

    targetParagraph.appendChild(wrapper);
    if (trailingSep) {
      targetParagraph.appendChild(trailingSep);
    } else {
      targetParagraph.appendChild(document.createTextNode("\u00A0"));
    }

    if (
      sourceParent &&
      sourceParent !== targetParagraph &&
      sourceParent.tagName === "P" &&
      paragraphOnlyContainsWrapper(sourceParent)
    ) {
      sourceParent.remove();
    }
  };

  const normalizeDynamicInputWrapperPlacement = useCallback((wrapper, editorRoot) => {
    if (!wrapper) return;

    const root = editorRoot || wrapper.closest(".fr-element");
    let li = wrapper.closest("li");

    if (!li && root) {
      const adjacentList =
        (wrapper.nextElementSibling?.tagName === "UL" || wrapper.nextElementSibling?.tagName === "OL"
          ? wrapper.nextElementSibling
          : null) ||
        (wrapper.previousElementSibling?.tagName === "UL" ||
        wrapper.previousElementSibling?.tagName === "OL"
          ? wrapper.previousElementSibling
          : null);
      if (adjacentList) {
        li =
          adjacentList.querySelector("li:last-child") ||
          adjacentList.querySelector("li");
        if (li) moveWrapperIntoListItem(wrapper, li);
      }
    }

    li = wrapper.closest("li");

    if (li) {
      const trailingSep =
        wrapper.nextSibling?.nodeType === Node.TEXT_NODE &&
        /^[\s\u00A0]*$/.test(wrapper.nextSibling.textContent)
          ? wrapper.nextSibling
          : null;
      const currentParagraph =
        wrapper.parentElement?.tagName === "P" ? wrapper.parentElement : null;
      const paragraphs = [...li.children].filter((child) => child.tagName === "P");

      let targetParagraph = null;
      if (
        currentParagraph &&
        li.contains(currentParagraph) &&
        !paragraphOnlyContainsWrapper(currentParagraph)
      ) {
        targetParagraph = currentParagraph;
      } else {
        targetParagraph =
          (currentParagraph?.previousElementSibling?.tagName === "P"
            ? currentParagraph.previousElementSibling
            : null) ||
          paragraphs.find(
            (paragraph) => paragraph !== currentParagraph && !isEmptyParagraph(paragraph)
          ) ||
          paragraphs[0] ||
          null;

        if (!targetParagraph) {
          targetParagraph = getListItemTargetParagraph(li);
        }

        if (currentParagraph !== targetParagraph) {
          targetParagraph.appendChild(wrapper);
          if (trailingSep) {
            targetParagraph.appendChild(trailingSep);
          } else {
            targetParagraph.appendChild(document.createTextNode("\u00A0"));
          }
          if (currentParagraph && paragraphOnlyContainsWrapper(currentParagraph)) {
            currentParagraph.remove();
          }
        }
      }

      [...li.children]
        .filter((child) => child.tagName === "P" && isEmptyParagraph(child))
        .forEach((paragraph) => paragraph.remove());
      [...li.children]
        .filter((child) => child.tagName === "UNDEFINED")
        .forEach((node) => node.remove());
      [...li.childNodes].forEach((child) => {
        if (child.nodeName === "BR") child.remove();
      });
      return;
    }

    // Previously this unconditionally pulled the wrapper back OUT of its <p>
    // (making it a "naked" inline node sitting directly under the editor
    // root, outside any paragraph) and then deleted that <p> whenever it was
    // left empty. That ran on every plain-paragraph insert -- not just some
    // edge case -- so adding an input into an empty line (e.g. after
    // pressing Enter a few times) silently deleted that line, and the
    // dynamic input ended up unwrapped. insertDynamicInputAtCursor /
    // appendDynamicInputAtEditorEnd already place the wrapper inside the
    // correct paragraph, so there's nothing to fix up here for the
    // non-list case -- leave it where it was inserted.
  }, []);

  const sanitizeInvalidEditorNodes = useCallback((editorRoot) => {
    if (!editorRoot) return;
    editorRoot.querySelectorAll("*").forEach((node) => {
      if (node.tagName !== "UNDEFINED") return;
      const parent = node.parentNode;
      if (!parent) return;
      while (node.firstChild) {
        parent.insertBefore(node.firstChild, node);
      }
      node.remove();
    });
  }, []);

  const finishDynamicInputInsert = useCallback(
    (editorInstance, wrapper, range, selection) => {
      const separator = document.createTextNode("\u00A0");
      wrapper.after(separator);
      range.setStartAfter(separator);
      range.collapse(true);
      selection.removeAllRanges();
      selection.addRange(range);

      const editorRoot = editorInstance.$el?.get(0);
      normalizeDynamicInputWrapperPlacement(wrapper, editorRoot);
      normalizeDynamicInputSeparators(editorRoot);
      sanitizeInvalidEditorNodes(editorRoot);
      editorInstance.events.trigger("contentChanged");
    },
    [normalizeDynamicInputWrapperPlacement, sanitizeInvalidEditorNodes]
  );

  const insertDynamicInputAtCursor = useCallback(
    (editorInstance, inputHtml) => {
      const editorRoot = editorInstance?.$el?.get(0);
      const selection = window.getSelection();
      if (!editorRoot || !selection?.rangeCount) return false;

      const range = selection.getRangeAt(0);
      if (!editorRoot.contains(range.commonAncestorContainer)) return false;

      const template = document.createElement("template");
      template.innerHTML = inputHtml.trim();
      const wrapper = template.content.firstElementChild;
      if (!wrapper) return false;

      const listItem = resolveListItemForInputInsert(editorRoot, range);

      if (listItem) {
        if (!listItem.contains(range.commonAncestorContainer)) {
          const targetParagraph = getListItemTargetParagraph(listItem);
          range.selectNodeContents(targetParagraph);
          range.collapse(false);
        } else {
          getListItemTargetParagraph(listItem, range);
        }
      } else {
        const rangeNode =
          range.startContainer.nodeType === Node.ELEMENT_NODE
            ? range.startContainer
            : range.startContainer.parentElement;
        const blockParent = rangeNode?.closest?.("p, div, blockquote, td, th");
        if (
          blockParent &&
          editorRoot.contains(blockParent) &&
          !blockParent.closest("li") &&
          !blockParent.contains(range.startContainer)
        ) {
          range.selectNodeContents(blockParent);
          range.collapse(false);
        }
      }

      if (!range.collapsed) {
        range.collapse(false);
      }

      range.deleteContents();
      range.insertNode(wrapper);
      finishDynamicInputInsert(editorInstance, wrapper, range, selection);
      return true;
    },
    [finishDynamicInputInsert]
  );

  const appendDynamicInputAtEditorEnd = useCallback(
    (editorInstance, inputHtml) => {
      const editorRoot = editorInstance?.$el?.get(0);
      if (!editorRoot) return false;

      const template = document.createElement("template");
      template.innerHTML = inputHtml.trim();
      const wrapper = template.content.firstElementChild;
      if (!wrapper) return false;

      const lists = editorRoot.querySelectorAll("ul, ol");
      if (lists.length) {
        const lastList = lists[lists.length - 1];
        const listItem =
          lastList.querySelector("li:last-child") || lastList.querySelector("li");
        if (listItem) {
          getListItemTargetParagraph(listItem).appendChild(wrapper);
          const range = document.createRange();
          const selection = window.getSelection();
          range.selectNodeContents(listItem);
          range.collapse(false);
          finishDynamicInputInsert(editorInstance, wrapper, range, selection);
          return true;
        }
      }

      let targetParagraph = editorRoot.querySelector("p:last-of-type");
      if (!targetParagraph) {
        targetParagraph = document.createElement("p");
        editorRoot.appendChild(targetParagraph);
      }

      targetParagraph.appendChild(wrapper);
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(targetParagraph);
      range.collapse(false);
      finishDynamicInputInsert(editorInstance, wrapper, range, selection);
      return true;
    },
    [finishDynamicInputInsert]
  );

  const normalizeDynamicInputSeparators = useCallback((editorRoot) => {
    if (!editorRoot) return;
    const wrappers = editorRoot.querySelectorAll(".froala-dynamic-input-wrapper, .froala-dropdown-wrapper");
    wrappers.forEach((wrapper) => {
      const prev = wrapper.previousSibling;
      if (prev && prev.nodeName === "BR" && prev.previousSibling?.nodeName !== "BR") {
        prev.remove();
      }

      const whitespaceTextNodes = [];
      let next = wrapper.nextSibling;
      while (next && next.nodeType === Node.TEXT_NODE && /^[\s\u00A0]*$/.test(next.textContent)) {
        whitespaceTextNodes.push(next);
        next = next.nextSibling;
      }
      if (whitespaceTextNodes.length > 1) {
        const firstText = whitespaceTextNodes[0];
        whitespaceTextNodes.slice(1).forEach((n) => n.remove());
        firstText.textContent = "\u00A0";
      } else if (
        whitespaceTextNodes.length === 0 &&
        next &&
        next.nodeName === "BR" &&
        next.nextSibling?.nodeName !== "BR"
      ) {
        next.remove();
      }
    });
  }, []);

  const handleDynamicInputRemovalKeydownRef = useRef(() => {});

 const isDynamicInputWrapper = (node) =>
  node?.nodeType === Node.ELEMENT_NODE &&
  (
    node.classList?.contains('froala-dynamic-input-wrapper') ||
    node.classList?.contains('froala-dropdown-wrapper') ||
    (
      node.tagName === 'SPAN' &&
      node.getAttribute('contenteditable') === 'false' &&
      (node.querySelector('input') || node.querySelector('select'))
    )
  );

  const getDynamicInputWrapper = (node) => {
    if (!node) return null;
    let current = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    while (current) {
      if (isDynamicInputWrapper(current)) return current;
      current = current.parentElement;
    }
    return null;
  };

  const isSkippableSeparatorNode = (node) =>
    node && node.nodeType === Node.TEXT_NODE && /^[\s\u00A0]*$/.test(node.textContent);

  const findDynamicInputWrapperBeforeCaret = (range) => {
    if (!range?.collapsed) return null;

    const { startContainer, startOffset } = range;

    if (startContainer.nodeType === Node.TEXT_NODE && startOffset > 0) {
      return null;
    }

    let probe = null;
    if (startContainer.nodeType === Node.TEXT_NODE) {
      probe = startContainer.previousSibling;
    } else if (startContainer.nodeType === Node.ELEMENT_NODE) {
      if (isDynamicInputWrapper(startContainer)) return startContainer;
      probe =
        startOffset > 0 ? startContainer.childNodes[startOffset - 1] : startContainer.previousSibling;
    }

    while (probe) {
      if (isDynamicInputWrapper(probe)) return probe;
      if (isSkippableSeparatorNode(probe)) {
        probe = probe.previousSibling;
        continue;
      }
      break;
    }

    return null;
  };

  const findDynamicInputWrapperAfterCaret = (range) => {
    if (!range?.collapsed) return null;

    const { startContainer, startOffset } = range;

    if (startContainer.nodeType === Node.TEXT_NODE) {
      if (startOffset < startContainer.textContent.length) return null;
      let probe = startContainer.nextSibling;
      while (probe) {
        if (isDynamicInputWrapper(probe)) return probe;
        if (isSkippableSeparatorNode(probe)) {
          probe = probe.nextSibling;
          continue;
        }
        break;
      }
      return null;
    }

    if (startContainer.nodeType === Node.ELEMENT_NODE) {
      if (isDynamicInputWrapper(startContainer)) return startContainer;
      let probe = startContainer.childNodes[startOffset] ?? null;
      if (!probe && startOffset >= startContainer.childNodes.length) {
        probe = startContainer.nextSibling;
      }
      while (probe) {
        if (isDynamicInputWrapper(probe)) return probe;
        if (isSkippableSeparatorNode(probe)) {
          probe = probe.nextSibling;
          continue;
        }
        break;
      }
    }

    return null;
  };

  const syncEditorAfterDynamicInputRemoval = useCallback((updatedContent) => {
    onChange?.(id, updatedContent);
    onBlur?.(id, updatedContent);
    if (id === 'introTextTE' && setEditorContent) {
      setEditorContent((prev) => ({ ...prev, innerHTML: updatedContent }));
    } else if (id === 'commentText' && setEditorContent) {
      setEditorContent((prev) => ({
        ...prev,
        commentText: { ...editorDataRef.current, innerHTML: updatedContent },
      }));
    } else if (id === 'commentSummary' && setEditorContent) {
      setEditorContent((prev) => ({
        ...prev,
        commentSummary: { ...editorDataRef.current, innerHTML: updatedContent },
      }));
    } else if (id === 'nonNarrativeComment' && setEditorContent) {
      setEditorContent((prev) => ({ ...prev, innerHTML: updatedContent }));
    }
  }, [id, onBlur, onChange, setEditorContent]);

  const removeDynamicInputWrapper = useCallback((wrapper) => {
    if (!wrapper?.parentNode) return;

    const editorRoot = editor.current?.editor?.$el?.get(0);
    const inputId = wrapper.querySelector('input')?.id;
    if (inputId) detachDynamicInputListeners(inputId);

    const leadingSep = wrapper.previousSibling;
    const trailingSep = wrapper.nextSibling;
    const anchorNode =
      leadingSep &&
      leadingSep.nodeType === Node.TEXT_NODE &&
      /^[\s\u00A0]*$/.test(leadingSep.textContent) &&
      !isDynamicInputWrapper(leadingSep.previousSibling)
        ? leadingSep.previousSibling
        : leadingSep;
    const parentNode = wrapper.parentNode;

    wrapper.remove();

    if (
      trailingSep &&
      trailingSep.nodeType === Node.TEXT_NODE &&
      /^[\s\u00A0]*$/.test(trailingSep.textContent)
    ) {
      trailingSep.remove();
    }
    if (
      leadingSep &&
      leadingSep.nodeType === Node.TEXT_NODE &&
      /^[\s\u00A0]*$/.test(leadingSep.textContent) &&
      !isDynamicInputWrapper(leadingSep.previousSibling)
    ) {
      leadingSep.remove();
    }

    if (editorRoot) normalizeDynamicInputSeparators(editorRoot);
    placeCaretInEditorAt(anchorNode, parentNode);

    const activeEditor = editor.current?.editor;
    if (!activeEditor) return;

    persistDynamicInputValues(activeEditor, editorDataRef.current?.dropdownList || editorData?.dropdownList);
    activeEditor.events.trigger("contentChanged");
    syncEditorAfterDynamicInputRemoval(activeEditor.html.get());
  }, [
    detachDynamicInputListeners,
    normalizeDynamicInputSeparators,
    persistDynamicInputValues,
    placeCaretInEditorAt,
    syncEditorAfterDynamicInputRemoval,
  ]);

  const resolveDynamicInputWrapperForBackspace = useCallback((editableRoot) => {
    if (!editableRoot) return null;

    const active = document.activeElement;

    if (active?.tagName === 'INPUT' && editableRoot.contains(active)) {
      const wrapper = getDynamicInputWrapper(active);
      if (!wrapper) return null;

      const value = active.value ?? '';
      const start = active.selectionStart ?? 0;
      const end = active.selectionEnd ?? 0;
      if (value !== '' && start > 0 && start === end) return null;
      if (value !== '' && start !== end) return null;

      return wrapper;
    }

    if (isDynamicInputWrapper(active) && editableRoot.contains(active)) {
      return active;
    }

    const selection = window.getSelection();
    if (!selection?.rangeCount || !editableRoot.contains(selection.anchorNode)) return null;

    const range = selection.getRangeAt(0);
    if (!range.collapsed) return null;

    const { startContainer } = range;
    if (startContainer.nodeType === Node.ELEMENT_NODE && isDynamicInputWrapper(startContainer)) {
      return startContainer;
    }

    const wrapperFromRange = getDynamicInputWrapper(startContainer);
    if (wrapperFromRange && editableRoot.contains(wrapperFromRange)) {
      const input = wrapperFromRange.querySelector('input');
      if (input && document.activeElement === input) return null;
      return wrapperFromRange;
    }

    return findDynamicInputWrapperBeforeCaret(range);
  }, []);

  const resolveDynamicInputWrapperForDelete = useCallback((editableRoot) => {
    if (!editableRoot) return null;

    const active = document.activeElement;

    if (active?.tagName === 'INPUT' && editableRoot.contains(active)) {
      const wrapper = getDynamicInputWrapper(active);
      if (!wrapper) return null;

      const value = active.value ?? '';
      const start = active.selectionStart ?? 0;
      const end = active.selectionEnd ?? 0;
      if (value !== '' && end < value.length && start === end) return null;
      if (value !== '' && start !== end) return null;

      return wrapper;
    }

    if (isDynamicInputWrapper(active) && editableRoot.contains(active)) {
      return active;
    }

    const selection = window.getSelection();
    if (!selection?.rangeCount || !editableRoot.contains(selection.anchorNode)) return null;

    const range = selection.getRangeAt(0);
    if (!range.collapsed) return null;

    const { startContainer } = range;
    if (startContainer.nodeType === Node.ELEMENT_NODE && isDynamicInputWrapper(startContainer)) {
      return startContainer;
    }

    const wrapperFromRange = getDynamicInputWrapper(startContainer);
    if (wrapperFromRange && editableRoot.contains(wrapperFromRange)) {
      const input = wrapperFromRange.querySelector('input');
      if (input && document.activeElement === input) return null;
      return wrapperFromRange;
    }

    return findDynamicInputWrapperAfterCaret(range);
  }, []);

  const bindDynamicInputRemovalKeydownHandler = useCallback((editorRoot) => {
    if (!editorRoot) return;
    const editableRoot = editorRoot.querySelector('.fr-element') || editorRoot;
    if (editableRoot.dataset.dynamicInputRemovalKeydownBound === 'true') return;
    editableRoot.dataset.dynamicInputRemovalKeydownBound = 'true';
    editableRoot.addEventListener(
      'keydown',
      (event) => handleDynamicInputRemovalKeydownRef.current(event),
      true
    );
  }, []);

  handleDynamicInputRemovalKeydownRef.current = (event) => {
    if (event.key !== 'Backspace' && event.key !== 'Delete') return;

    const editorRoot = editor.current?.editor?.$el?.get(0);
    const editableRoot = editorRoot?.querySelector('.fr-element') || editorRoot;
    const wrapper =
      event.key === 'Backspace'
        ? resolveDynamicInputWrapperForBackspace(editableRoot)
        : resolveDynamicInputWrapperForDelete(editableRoot);
    if (!wrapper) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    removeDynamicInputWrapper(wrapper);
  };

  useEffect(() => {
    return () => {
      dynamicInputObserverRef.current?.disconnect();
      dynamicInputObserverRef.current = null;
      dynamicInputObserverRootRef.current = null;
      [...dynamicInputListenersRef.current.keys()].forEach(detachDynamicInputListeners);
    };
  }, [detachDynamicInputListeners]);

  useEffect(() => {
    editorDataRef.current = editorData;
  }, [editorData]);

  useEffect(() => {
    bindDynamicInputRemovalKeydownHandler(editor.current?.editor?.$el?.get(0));
  }, [bindDynamicInputRemovalKeydownHandler, editorData?.innerHTML]);

  useEffect(() => {
    anchorElRef.current = anchorEl;
  }, [anchorEl]);

  const categoryTags = React.useMemo(() => {
    const categories = (AllCategoryList || templateData)?.template?.categories || [];
    const selectedCategoryFromStore = storeData?.showClModal?.selectedCategory;

    let currentCategory = categories.find(cat => cat.category_id === selectedCategoryFromStore?.id);

    if (!currentCategory && commentData?.comment_id) {
      currentCategory = categories.find(cat =>
        cat.lines?.some(line =>
          line.comments?.some(com => com.comment_id === commentData?.comment_id || com.comment_uuid === commentData?.comment_uuid)
        )
      );
    }

    const categoryTags = currentCategory?.narrative_categories_tags || currentCategory?.nn_categories_tags || [];
    return categoryTags.map(item => ({
      id: item.tag?.id,
      title: item.tag?.name || item.tag?.title,
      color: item.tag?.color
    })).filter(tag => tag.id);
  }, [AllCategoryList, templateData, storeData?.showClModal?.selectedCategory, commentData?.comment_id, commentData?.comment_uuid]);

  const getDropdownUuidFromInputId = (inputId) => inputId?.replace("dropdown_", "") ?? "";

  const resolveDropdownList = ({ prevList, editorList, commentDropdowns, localList } = {}) => {
    if (Array.isArray(prevList) && prevList.length > 0) return [...prevList];
    if (Array.isArray(editorList) && editorList.length > 0) return [...editorList];
    if (Array.isArray(commentDropdowns) && commentDropdowns.length > 0) return [...commentDropdowns];
    if (Array.isArray(localList) && localList.length > 0) return [...localList];
    return [];
  };

  const updateDropdownSelection = (list, dropdownUuid, value) =>
    list.map((dropdown) =>
      dropdown?.dropdown_uuid === dropdownUuid
        ? { ...dropdown, selected_value: value }
        : dropdown
    );

  const handleOpenDialog = async (event, dropdownsList) => {
    setAnchorEl(null);
    event?.stopPropagation();
    setState({ ...state, open: true, isDialogLoading: true });
    let response
    if ((event?.target?.name === "commentText" || event?.target?.name === "nonNarrativeComment") && setActiveEditorId) {
      setActiveEditorId(event?.target?.name);
    }
    else if (event?.target?.name === "commentSummary" && setActiveEditorId) {
      setActiveEditorId(event?.target?.name);
    }
    let newButtonId = event?.target?.id?.replace("dropdownButton", "");
    if (event?.target?.tagName === "BUTTON") {
      const parentSpan = event?.target?.closest('span[contenteditable="false"]');
      const parentSpanId = parentSpan?.id;
      let newButtonId = event?.target?.getAttribute("data-dropdown-id") ||
        event?.target?.id?.replace("dropdownButton", "").replace("dropdownIcon_", "");
      if (!newButtonId && parentSpanId) {
        newButtonId = parentSpanId.replace("[dropdown ", "").replace("]", "");
      }
      let dropdown;
      dropdown = asArrayOrNull(dropdownList)?.find((obj) => obj?.dropdown_uuid === newButtonId);
      if (dropdown === undefined) dropdown = (asArrayOrNull(editorDataRef.current?.dropdownList) || asArrayOrNull(editorData?.dropdownList))?.find((obj) => obj?.isPasted === true);
      if (dropdown?.length === 0 || dropdown === undefined) dropdown = asArrayOrNull(dropdownsList)?.find((obj) => obj?.dropdown_uuid === newButtonId);
      if (dropdown === undefined) { if (id === "commentText" || id === "nonNarrativeComment") dropdown = asArrayOrNull(commentData?.comment_dropdowns)?.find((obj) => obj?.dropdown_uuid === newButtonId); else dropdown = asArrayOrNull(commentData?.summary_comment_dropdowns)?.find((obj) => obj?.dropdown_uuid === newButtonId); }
      if (dropdown === undefined) dropdown = (asArrayOrNull(editorDataRef.current?.dropdownList) || asArrayOrNull(editorData?.dropdownList))?.find((obj) => obj?.dropdown_uuid === newButtonId);
      if (dropdown?.list_guid) {
        response = await dispatch(getGlobalListById(dropdown?.list_guid));
        if (response?.deleted_at) {
          const editorInstance = editor?.current?.editor;
          let editorContent = editorInstance?.html?.get();
          let newDropdownList = asArrayOrNull(editorDataRef.current?.dropdownList) || asArrayOrNull(editorData?.dropdownList) || asArrayOrNull(dropdownsList) || asArrayOrNull((id === "commentText" || id === "nonNarrativeComment") ? commentData?.comment_dropdowns : commentData?.summary_comment_dropdowns) || [];
          let newIndex = newDropdownList?.findIndex((obj => obj?.list_guid === dropdown?.list_guid))
          newDropdownList[newIndex] = { ...newDropdownList[newIndex], list_guid: undefined, dropdowns_values: response?.options };
          if (id === "introTextTE" && setEditorContent) {
            onBlur?.(id, editorContent, newDropdownList[newIndex], "edit");
            handleDropdownList?.(id, newDropdownList);
            setEditorContent(prevState => ({ ...prevState, dropdownList: newDropdownList }));
          } else if (id === "commentText" && setEditorContent) {
            onBlur?.(id, editorContent, newDropdownList);
            setEditorContent(prevState => ({ ...prevState, commentText: { dropdownList: newDropdownList }, commentDropdownList: newDropdownList }));
          } else if (id === "commentSummary" && setEditorContent) {
            onBlur?.(id, editorContent, newDropdownList);
            setEditorContent(prevState => ({ ...prevState, commentSummary: { dropdownList: newDropdownList }, summaryDropdownList: newDropdownList }));
          } else if (id === "nonNarrativeComment") {
            onBlur?.(id, editorContent, newDropdownList);
            setEditorContent(prevState => ({ ...prevState, dropdownList: newDropdownList }));
          }
        }
      }
      setAnchorEl(null);
      setState((prevState) => ({
        ...prevState,
        dialogOptionList: response?.options || dropdown?.dropdowns_values,
        open: "edit_list",
        selectedDropdown: newButtonId || dropdown?.dropdown_uuid,
        name: response?.name,
        description: response?.description,
        tags: response?.tags,
        saveToGlobalLists: dropdown?.list_guid ? response?.deleted_at ? false : true : false,
        listId: response?.deleted_at ? undefined : response?.id,
        listGuid: response?.deleted_at ? undefined : dropdown?.list_guid,
      }));
      setState((prevState) => ({ ...prevState, isDialogLoading: false }))
    }
  };

  useEffect(() => {
    const editorInstance = editor?.current?.editor;
    let editorContent = editorInstance?.html?.get();
    if (!editorInstance || !editorData?.innerHTML) return;
    let isEffectExecuted = false;
    let newDropdownList = dropdownList?.length > 0 ? [...dropdownList] : [];
    const returnButtonElement = (dropdown) => {
      const buttonElement = document.createElement("button");
      buttonElement.setAttribute("id", `dropdownButton${dropdown.dropdown_uuid}`);
      buttonElement.setAttribute("contenteditable", "false");
      buttonElement.setAttribute("name", `${dropdown.dropdown_uuid}`);
      buttonElement.classList.add("dropdown-button");
      buttonElement.setAttribute("type", "button");
      buttonElement.addEventListener("click", (event) => {
        handleOpenDialog(event, dropdown.dropdown_uuid);
      });
      buttonElement.style.cssText = `background-color: #f1f9fe;
          width: 24px;
          height: 24px;
          padding: 0px;
          color: #0F75BC;
          border-radius: 4px 0px 0px 4px;
          border: 1px solid #0F75BC;
          position: relative;
          transform: scaleX(-1);
          font-size: 17px;
          margin-left: -4px;
          top: 2.5px;`;
      buttonElement.textContent = "✎";
      return buttonElement;
    }
    const returnStyleElement = (dropdown) => {
      const styleTag = document.createElement("style");
      styleTag.innerHTML = `
        @media screen and (max-width: 1100px) {
          #dropdownButton${dropdown.dropdown_uuid} {
            top: 25.5px;
          }
        }
        @media screen and (min-width: 1600px) {
          #dropdownButton${dropdown.dropdown_uuid} {
            top: 2.5px;
            width: initial;
            margin-left: -5px;
          }
        }
        @media screen and (min-width: 1700px) {
          #dropdownButton${dropdown.dropdown_uuid} {
            top: 2.5px;
            width: initial;
            margin-left: -5px;
          }
        }
        @media screen and (min-width: 1800px) {
          #dropdownButton${dropdown.dropdown_uuid} {
            top: 2.5px;
            width: initial;
            margin-left: -5px;
          }
        }
        @media screen and (min-width: 1900px) {
          #dropdownButton${dropdown.dropdown_uuid} {
            top: 2px;
            width: initial;
            margin-left: -5px;
          }
        }
        @media screen and (min-width: 2000px) {
          #dropdownButton${dropdown.dropdown_uuid} {
            top: 1.5px;
            width: initial;
            margin-left: -5px;
          }
        }
        @media screen and (min-width: 2100px) {
          #dropdownButton${dropdown.dropdown_uuid} {
            top: 1.5px;
            width: initial;
            margin-left: -5px;
          }
        }
      `;
      return styleTag;
    }
    const replacePlaceholdersWithDropdowns = () => {
      const isValidSelectedValue = (val) => {
        if (val === null || val === undefined) return false;
        const str = String(val).trim();
        return str !== "" && str.toLowerCase() !== "null" && str.toLowerCase() !== "undefined" && !str.includes("------");
      };
      
      const rawDropdowns = id === "introTextTE" ? commentData?.introductory_text_dropdowns : id === "commentText" || id === "nonNarrativeComment" ? commentData?.comment_dropdowns : commentData?.summary_comment_dropdowns;
      const dropdowns = Array.isArray(rawDropdowns)
        ? rawDropdowns
        : (rawDropdowns && typeof rawDropdowns === "object" && rawDropdowns.dropdown_uuid ? [rawDropdowns] : rawDropdowns);
      const regexPlainDropdown = /\[dropdown ([a-f0-9\-]+)\]/gi;
      if (Array?.isArray(dropdowns) && dropdowns?.length > 0) {
        const tempContainer = document.createElement("div");
        tempContainer.innerHTML = editorData?.innerHTML;
        if (copy) {
          dropdowns.forEach((dropdown) => {
            const spanElements = Array.from(tempContainer.querySelectorAll(`span[contenteditable="false"][id="[dropdown_${dropdown.dropdown_uuid}]"]`));
            spanElements.forEach((spanElement) => {
              let optionValues = [];
              spanElement.innerHTML = "";
              spanElement.contentEditable = "false";
              const selectElement = document.createElement("select");
              let originalValues = Array.isArray(dropdown?.dropdowns_values?.values) ? dropdown?.dropdowns_values?.values : dropdown?.dropdowns_values;
              let newDropdownValues = Array.isArray(originalValues) ? [...originalValues] : [];
              if (Array.isArray(newDropdownValues)) {
                newDropdownValues = newDropdownValues.filter((obj) => obj != null && typeof obj === 'string' && !obj.toUpperCase().includes("XXXXX"));
                const hasValidSelectedValue = isValidSelectedValue(dropdown?.selected_value);
                if (hasValidSelectedValue) {
                  const hasSelectedValue = newDropdownValues.some(val => val?.trim() === dropdown.selected_value?.trim());
                  if (!hasSelectedValue) {
                    newDropdownValues.push(dropdown.selected_value);
                  }
                }
                if (!newDropdownValues.find((value) => value.includes("------"))) {
                  newDropdownValues.unshift("-------------");
                }
                newDropdownValues.forEach((value) => {
                  const option = document.createElement("option");
                  option.text = value?.length > 40 ? `${value.substring(0, 40)}...` : value || "";
                  option.value = value || "";
                  option.title = value || "";
                  if (hasValidSelectedValue) {
                    if (dropdown?.selected_value === value) {
                      option.setAttribute("selected", value);
                    }
                  } else {
                    if (value === "-------------") {
                      option.setAttribute("selected", value);
                    }
                  }
                  selectElement.appendChild(option);
                });
              }
              selectElement.classList.add(`${id === "introTextTE" ? "intro" : id === "commentText" ? "comment" : "summary"}-dropdown`);
              selectElement.setAttribute("id", dropdown.dropdown_uuid);
              if (id !== "introTextTE") {
                selectElement.setAttribute("comment_id", commentData?.comment_id);
                selectElement.setAttribute("comment_uuid", commentData?.comment_uuid);
                selectElement.setAttribute("dropType", id === "commentText" ? "comment" : "summary");
              }
              optionValues = Array.from(selectElement.options)
                .map((option) => option.value)
                .filter((value) => value !== "-------------");
              newDropdownList.push({
                dropdown_uuid: dropdown?.dropdown_uuid,
                name: dropdown?.name || "",
                selected_value: dropdown?.selected_value,
                dropdowns_values: optionValues || [],
                isPasted: true,
                list_guid: dropdown?.list_guid,
              });
              spanElement.appendChild(selectElement);
              const buttonElement = returnButtonElement(dropdown);
              spanElement.appendChild(buttonElement);
              const styleTag = returnStyleElement(dropdown);
              document.head.appendChild(styleTag);
            });
          });
          editorData.innerHTML = tempContainer.innerHTML;
        } else {
          var placeholderRegex = /\[dropdown\s([a-f0-9-]+)\]/gi;
          const selectRegex = /<select\b[^>]*id="([a-f0-9-]+)"[^>]*>([\s\S]*?)<\/select>/gi;
          editorData.innerHTML = editorData?.innerHTML
            ?.replace(placeholderRegex, (match, dropdownId) => createDropdownHTML(dropdownId))
            ?.replace(selectRegex, (match, dropdownId) => createDropdownHTML(dropdownId));
          function createDropdownHTML(dropdownId) {
            const dropdown = dropdowns?.find((item) => item?.dropdown_uuid === dropdownId);
            if (!dropdown) return "";
            newDropdownList.push({
              dropdown_uuid: dropdownId,
              name: dropdown?.name || "",
              selected_value: dropdown?.selected_value,
              dropdowns_values: dropdown?.dropdowns_values || [],
              isPasted: true,
              list_guid: dropdown?.list_guid,
            });
            const safeValue = dropdown?.selected_value?.trim().toUpperCase() === "XXX" ? "" :
              (dropdown?.selected_value || "").replace(/\\/g, "\\\\").replace(/"/g, "&quot;");
            const commentAttrs = id !== "introTextTE"
              ? ` comment_id="${commentData?.comment_id}" comment_uuid="${commentData?.comment_uuid}" dropType="${id === "commentText" || id === "nonNarrativeComment" ? "comment" : "summary"}"`
              : "";
            return ` <span contenteditable="false" style="display:inline-flex; align-items:center; vertical-align:middle; line-height:normal; margin: 0 2px;" id="dropdown_${dropdownId}">
                          <input id="dropdown_${dropdownId}" ${commentAttrs}  class="froala-dropdown-input"
                              value="${safeValue}"
                              placeholder="Type or select from dropdown"
                              autocomplete="off"
                              autocorrect="off"
                              spellcheck="false"
                              style="width: 220px;
                              background-color: #f1f9fe;
                              height: 23px; 
                              padding: 4px 8px;
                              vertical-align: middle;
                              border-top: 1px solid #4282e2;
                              border-bottom: 1px solid #4282e2;
                              border-left: 1px solid #4282e2;
                              border-right: none; 
                              border-radius: 4px 0px 0px 4px; 
                              font-size: 14px;
                              font-weight: 600;
                              color: #3B3B3B;
                              cursor: text;
                              text-align: left;
                              display: inline-block;"
                              />
                               <style>
                              .froala-dropdown-input::placeholder {
                                font-style: italic;
                                font-weight:400;
                                }
                              </style>
                              <button
                                contenteditable="false" 
                                class="fr-disabled"
                                tabindex="-1"
                                id="dropdownIcon_${dropdownId}"
                                name="${id}"
                                type="button"
                                data-dropdown-id="${dropdownId}"
                                onclick="window.openDropdown('dropdown_${dropdownId}', event)"
                                style="background-color: #f1f9fe;
                                width: 23px;
                                height: 23px !important;
                                border: 1px solid #4282e2;
                                border-right: 0px solid blue;
                                vertical-align: middle;
                                margin-left: 0px;
                                font-size: 14px;
                                color: #4282e2;
                                display: inline-flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;"
                              >
                              ▾
                              </button>
                              <button id="dropdownButton${dropdownId}" name="${id}"
                              class="fr-disabled"
                              contenteditable="false" 
                              tabindex="-1"
                              style="background-color: #f1f9fe;
                              width: 24px; 
                              height: 23px !important; 
                              border: 1px solid #4282e2;
                              border-radius: 0px 4px 4px 0px;
                              margin-left:0px;
                              font-size: 14px;
                              color: #4282e2;
                              display: inline-flex;
                              align-items: center;
                              justify-content: center;
                              vertical-align: middle;
                              cursor: pointer;">
                                ✎
                              </button>
                    </span>`;
          }
        }
      } else {
        const outputString = editorData?.innerHTML?.replace(regexPlainDropdown, (match, selectId) => {
          return ` <span id="dropdown_${selectId}" contenteditable="false" style="display: inline-flex; align-items: center; margin-left:2px;"><input id="dropdown_${selectId}" value=""
                              placeholder="Type or select from dropdown"
                              autocomplete="off"
                              autocorrect="off"
                              spellcheck="false"
                              style="width: 220px;
                              background-color: #f1f9fe;
                              height: 23px !important; 
                              padding: 4px 8px;
                              vertical-align: middle;
                              border-top: 1px solid #4282e2;
                              border-bottom: 1px solid #4282e2;
                              border-left: 1px solid #4282e2;
                              border-right: none; 
                              border-radius: 4px 0px 0px 4px; 
                              font-size: 14px;
                              font-weight: 600;
                              color: #3B3B3B;
                              cursor: text;
                              text-align: left;
                              display: inline-block;"
                              class="froala-dropdown-input"
                              />
                               <style>
                              .froala-dropdown-input::placeholder {
                                font-style: italic ! important;
                                font-weight:400 ! important;
                                }
                              </style><button type="button" contenteditable="false"
                                name="${id}"
                                id="dropdownIcon_${selectId}"
                                data-dropdown-id="${selectId}"
                                onclick="window.openDropdown('dropdown_${selectId}', event, null, '${commentData?.comment_uuid}')"
                                style="background-color: #f1f9fe;
                                  width: 26px;
                                  height: 24px !important;
                                  border: 1px solid #4282e2;
                                  border-right: 1px solid #4282e2;
                                  vertical-align: middle;
                                  margin-left: -3px;
                                  font-size: 14px;
                                  color: #4282e2;
                                  display: inline-flex;
                                  align-items: center;
                                  justify-content: center;
                                  cursor: pointer;
                                  padding-right: 2px;
                                  border-radius: 0px 4px 4px 0px;">
                                ▾
                              </button><button contenteditable="false"
                            id="dropdownButton${selectId}"
                            name="${id}"
                            style="
                              background-color: #f1f9fe;
                              width: 24px;
                              height: 24px;
                              border: 1px solid #4282e2;
                              border-radius: 0 4px 4px 0;
                              margin-left: -3px;
                              font-size: 14px;
                              color: #4282e2;
                              display: inline-flex;
                              align-items: center;
                              justify-content: center;
                              cursor: pointer;
                            "
                          >✎</button></span>`
        });
        editorData.innerHTML = outputString;
      }
      return copy ? decodeEntities(editorData.innerHTML) : editorData.innerHTML;
    };
    const replaceInputs = (input_text) => {
      let container = document.createElement("div");
      container.innerHTML = input_text;
      container.innerHTML = container.innerHTML.replace(/\[textbox (.*?)\]/g, (match, attributes) => {
        let idMatch = attributes.match(/id:([^;]+);?/);
        let valueMatch = attributes.match(/value:([^;]+);?/);
        let inputId = idMatch && idMatch[1].length > 30 ? idMatch[1].trim() : uuid();
        let value = valueMatch ? valueMatch[1].trim() : "";
        const safeValue = value.replace(/\\/g, "\\\\").replace(/"/g, "&quot;");
        return `<input id="${inputId}" value="${safeValue}" title="${safeValue}" style="width: 104px;
                background-color: #f1f9fe;
                height: 24px !important;
                overflow-wrap: break-word;
                padding: 1px 17px 3px 6px;
                border-radius: 4px;
                border: 1px solid #0F75BC;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                font-size: 14px !important;
                color: #3B3B3B !important;
                font-style: normal !important;
                font-weight: 600 !important;
                max-width: 200px !important;
                min-width: 104px !important;
                text-overflow: ellipsis !important;
                white-space: nowrap !important;"
                onblur="handleChangeInput(inputId, value)"
                />`;
      });
      return container.innerHTML;
    }
    const resyncDropdownInputValues = (htmlString) => {
      if (!htmlString || typeof htmlString !== "string" || !htmlString.includes("froala-dropdown-input")) return htmlString;
      const rawSourceDropdowns = id === "introTextTE" ? commentData?.introductory_text_dropdowns : id === "commentText" || id === "nonNarrativeComment" ? commentData?.comment_dropdowns : commentData?.summary_comment_dropdowns;
      const sourceDropdowns = Array.isArray(rawSourceDropdowns)
        ? rawSourceDropdowns
        : (rawSourceDropdowns && typeof rawSourceDropdowns === "object" && rawSourceDropdowns.dropdown_uuid ? [rawSourceDropdowns] : []);
      if (!sourceDropdowns.length) return htmlString;
      const container = document.createElement("div");
      container.innerHTML = htmlString;
      let changed = false;
      container.querySelectorAll("input.froala-dropdown-input").forEach((inputEl) => {
        const dropdownUuid = inputEl.id?.replace(/^dropdown_/, "") ?? "";
        const match = sourceDropdowns.find((d) => d?.dropdown_uuid === dropdownUuid);
        if (match?.selected_value) {
          const safeValue = match.selected_value.trim().toUpperCase() === "XXX" ? "" : String(match.selected_value).replace(/"/g, "&quot;");
          inputEl.setAttribute("value", safeValue);
          inputEl.setAttribute("title", safeValue);
          changed = true;
        }
      });
      return changed ? container.innerHTML : htmlString;
    };
    setTimeout(() => {
      if (!isEffectExecuted && editorContent === undefined) {
        isEffectExecuted = true;
        let newHtmlData = replacePlaceholdersWithDropdowns();
        newHtmlData = replaceInputs(newHtmlData);
        newHtmlData = resyncDropdownInputValues(newHtmlData);
        editorInstance.html.set(newHtmlData);
        const editorRoot = editorInstance.$el.get(0);
        editorRoot.focus();
        editorInstance.selection.setAtEnd(editorRoot);
        editorInstance.selection.restore();
      }
    }, 100);
    return () => {
      isEffectExecuted = false;
    };
  }, [commentData, id, copy]);

  const handleModelChange = (model) => {
    if (setCopied) setCopied(false);
    let htmlString = model;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const pastedElements = doc?.querySelectorAll(`[id^="isPasted"], [id^="pasted/"], #isPasted`);
    const spanElements = doc?.querySelectorAll("span:not([id]):has(select)");
    let checkPaste = false;
    if (pastedElements.length > 0) {
      pastedElements.forEach((element) => {
        if (element?.tagName === "SPAN" || element?.tagName === "SELECT") {
          if (element?.tagName === "SPAN") {
            const selectElement = element?.querySelector("select");
            if (selectElement) {
              checkPaste = true;
              element.remove();
            }
          } else if (element?.tagName === "SELECT") {
            checkPaste = true;
            element.remove();
          }
        } else if (element?.tagName === "BR" || element?.tagName === "P") {
          function findNextSpan(node) {
            while (node) {
              if (node?.tagName === "SPAN" || node?.tagName === "SELECT") return node;
              if (node?.tagName === "P") {
                const nestedSpan = node?.querySelector("span");
                if (nestedSpan) return nestedSpan;
                const nestedSelect = node?.querySelector("select");
                if (nestedSelect) return nestedSelect;
              }
              node = node.nextElementSibling;
            }
            return null;
          }
          const targetSpan = findNextSpan(element.nextElementSibling);
          if (targetSpan?.tagName === "SPAN") {
            const selectElement = targetSpan?.querySelector("select");
            if (selectElement) {
              checkPaste = true;
              selectElement.remove();
            }
          } else if (targetSpan?.tagName === "SELECT") {
            checkPaste = true;
            targetSpan.remove();
          }
          else if (element?.tagName === "INPUT") {
            checkPaste = false;
            const newInputUuid = uuid();
            element.id = newInputUuid;
          }
        } else if (element?.tagName === "INPUT") {
          checkPaste = false;
          const newInputUuid = uuid();
          element.id = newInputUuid;
        }
      });
      if (spanElements.length > 0) {
        spanElements.forEach((element) => {
          const selectElement = element?.querySelector("select");
          if (selectElement && !selectElement?.id) {
            checkPaste = true;
            selectElement.remove();
          }
          const buttonElement = element?.querySelector("button");
          if (buttonElement && !buttonElement?.id) {
            checkPaste = true;
            buttonElement.remove();
          }
        });
      }
    }
    const inputs = doc.body.querySelectorAll("input");
    inputs.forEach((element) => {
      if (!element.id || element.id === "isPasted" || document.getElementById(element.id)) {
        let newInputUuid;
        do {
          newInputUuid = uuid();
        } while (document.getElementById(newInputUuid)); // Ensure unique ID
        element.id = newInputUuid;
      }
    });
    if (checkPaste) {
      setState((prevState) => ({ ...prevState, openRemoveDropdown: doc.body.innerHTML }));
    } else {
      setTimeout(() => {
        const editorInstance = editor.current?.editor;
        const updatedDropdownList = persistDynamicInputValues(
          editorInstance,
          getDropdownListSource()
        );
        const updatedContent = editorInstance?.html.get();
        setState(prevState => ({ ...prevState, isFocused: true }))
        onChange(id, updatedContent);
        syncEditorStateWithDropdowns(updatedContent, updatedDropdownList);
        if (onBlur) {
          onBlur(id, updatedContent);
          syncChangedDropdownsOnBlur(updatedContent, updatedDropdownList);
        }
      }, 0);
    }
  };

  const cleanPastedHtml = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    doc.querySelectorAll('span[id^="dropdown_"]').forEach(span => span.remove());
    return doc.body.textContent.trim();
  };

  const handlePasteBefore = (event) => {
    const editorInstance = editor?.current?.editor;
    if (!editorInstance || !event.clipboardData) return;
    const pasteHtml = event.clipboardData.getData("text/html") || event.clipboardData.getData("text/plain");
    const parser = new DOMParser();
    const doc = parser.parseFromString(pasteHtml, "text/html");
    const selects = doc.querySelectorAll("input.froala-dropdown-input");
    const links = doc.querySelectorAll("a");
    const hasURL = /(https?:\/\/[^\s<]+|www\.[^\s<]+[^.,;:"')\]\s<])/gi.test(pasteHtml);
    const isWordContent = /class="?Mso|style="[^"]*mso-|<o:p>|<!--\[if gte mso|xmlns:o="/i.test(pasteHtml);
    const removeWordArtifacts = (node) => {
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_ALL, null, false);
      let current;
      while ((current = walker.nextNode())) {
        if (current.nodeType === Node.COMMENT_NODE) {
          current.remove(); // Remove <!--[if gte mso]> ... <![endif]-->
        } else if (current.nodeType === Node.ELEMENT_NODE) {
          const tag = current.nodeName.toLowerCase();
          // Remove <o:p> and other office-specific tags
          if (tag.startsWith("o:") || tag.startsWith("v:") || tag === "o:p") {
            current.remove();
            continue;
          }
          // Strip mso styles
          if (current.hasAttribute("style")) {
            const cleanedStyle = current
              .getAttribute("style")
              .replace(/mso-[^:;]+:[^;]+;?/gi, "")
              .replace(/background(-color)?:[^;]+;?/gi, "");
            current.setAttribute("style", cleanedStyle);
          }
          // Strip Word classes
          if (current.hasAttribute("class") && /Mso|WordSection/i.test(current.getAttribute("class"))) {
            current.removeAttribute("class");
          }
        }
      }
    };
    removeWordArtifacts(doc.body);
    const cleanedHTML = doc.body.innerHTML.trim();
    if (isWordContent || selects.length > 0 || hasURL) {
      event.preventDefault();
    }
    if (selects.length > 0 && [...selects].every((item) => item.id?.trim() !== "")) {
      event.preventDefault();
      setState((prev) => ({
        ...prev,
        openRemoveDropdown: cleanPastedHtml(cleanedHTML),
      }));
      return false;
    }
    if (isWordContent) {
      setState((prev) => ({
        ...prev,
        openWordPastePopup: {
          raw: pasteHtml,
          clean: cleanPastedHtml(cleanedHTML),
        },
      }));
      return;
    }
    if (hasURL && !links.length) {
      let formattedHtml = cleanedHTML.replace(
        /((https?:\/\/|www\.)[^\s<]+[^.,;:"')\]\s<])/gi,
        '<a href="$1" target="_blank">$1</a>'
      );
      formattedHtml = formattedHtml.replace(/href="www\./g, 'href="http://www.');
      editorInstance?.html?.insert(formattedHtml);
      return;
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setAnchorEl(null);
    };
    const scrollContainer = document.querySelector('.inspection-details');
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);
    }
    let froalaScrollContainer = null;
    let retryCount = 0;
    const maxRetries = 10;
    const retryDelay = 200;
    let retryTimer;
    const tryAttachFroalaScroll = () => {
      froalaScrollContainer =
        document.querySelector('.fr-scroller') ||
        document.querySelector('.fr-wrapper') ||
        document.querySelector('.fr-element') ||
        document.querySelector('.fr-box.fr-basic');
      if (froalaScrollContainer) {
        froalaScrollContainer.addEventListener('scroll', handleScroll);
      } else if (retryCount < maxRetries) {
        retryCount++;
        retryTimer = setTimeout(tryAttachFroalaScroll, retryDelay);
      } else {
        console.warn("Froala scroll container not found after retries.");
      }
    };
    tryAttachFroalaScroll();
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', handleScroll);
      }
      if (froalaScrollContainer) {
        froalaScrollContainer.removeEventListener('scroll', handleScroll);
      }
      clearTimeout(retryTimer);
    };
  }, []);

  const handleInputBlur = (event, inputId, value, dropdownsList) => {
    if (event?.target?.tagName === "SELECT") return;
    // Skip persisting the typed value when the blur is caused by interacting with the
    // dropdown popover (open) or while a selection is being applied. Otherwise the
    // previously typed text would overwrite the value chosen from the dropdown.
    if (anchorElRef.current || suppressBlurPersistRef.current) return;
    const editorInstance = editor.current?.editor;
    if (!editorInstance) return;
    let newDropdownList = Array.isArray(dropdownsList)
      ? [...dropdownsList]
      : getDropdownListSource().map((d) => ({ ...d }));
    const editorElement = editorInstance.$el.get(0);
    const allInputs = editorElement.querySelectorAll('input');
    allInputs.forEach(input => {
      const newValue = input.id === inputId ? input.value.replace(/"/g, "&quot;").trim() : input.value.trim();
      input.setAttribute("value", newValue);
      input.setAttribute("title", newValue);
      if (input.classList.contains('froala-dropdown-input')) {
        const dropdownUuid = input.id?.replace(/^dropdown_/, "") ?? "";
        let dropdownIndex = newDropdownList.findIndex(d => d.dropdown_uuid === dropdownUuid);
        if (dropdownIndex !== -1) {
          newDropdownList[dropdownIndex] = {
            ...newDropdownList[dropdownIndex],
            selected_value: newValue
          };
        } else {
          newDropdownList.push({
            dropdown_uuid: dropdownUuid,
            name: "",
            selected_value: newValue,
            dropdowns_values: dialogOptionList
          });
        }
      }
    });
    editorInstance.events.trigger("contentChanged");
    const updatedHtml = editorInstance.html.get();
    if (setEditorContent && (id === "introTextTE" || id === "commentText" || id === "commentSummary" || id === "nonNarrativeComment")) {
      syncEditorStateWithDropdowns(updatedHtml, newDropdownList);
    } else if (id === "introTextTE" && setEditorContent) {
      setEditorContent(prevState => ({ ...prevState, innerHTML: updatedHtml, dropdownList: newDropdownList }));
    } else if (id === "commentText" && setCommentText) {
      setCommentText(prev => ({ ...prev, innerHTML: updatedHtml, dropdownList: newDropdownList }));
    } else if (id === "commentSummary" && setCommentSummary) {
      setCommentSummary(prev => ({ ...prev, innerHTML: updatedHtml, dropdownList: newDropdownList }));
    } else if (id === "nonNarrativeComment" && setEditorContent) {
      setEditorContent(prevState => ({ ...prevState, innerHTML: updatedHtml, dropdownList: newDropdownList }));
    }
    const blurDropdownUuid = inputId?.replace(/^dropdown_/, "") ?? inputId;
    const isDropdownBlur = event?.target?.classList?.contains('froala-dropdown-input');
    if (isDropdownBlur && onBlur) {
      const changedDropdown = newDropdownList.find(d => d.dropdown_uuid === blurDropdownUuid);
      if (changedDropdown) {
        if (id === "commentText" || id === "commentSummary" || id === "nonNarrativeComment") {
          onBlur(id, updatedHtml, newDropdownList, "edit");
        } else {
          onBlur(id, updatedHtml, changedDropdown, "edit");
        }
      }
    } else if (onBlur && id === "introTextTE") {
      onBlur(id, updatedHtml);
    }
    const hasDropdownInputs = Array.from(allInputs).some(input => input.classList.contains('froala-dropdown-input'));
    if (handleIntroSave) {
      if (hasDropdownInputs) {
        const changedDropdown = newDropdownList.find(d => d.dropdown_uuid === blurDropdownUuid);
        handleIntroSave(changedDropdown ? [changedDropdown] : undefined, null, undefined, false);
      } else if (hasChanges) {
        handleIntroSave(null, null, updatedHtml);
      }
    }
    if (setHasChanges) setHasChanges(false);
  };

  useEffect(() => {
    const editorInstance = editor?.current?.editor;
    if (!editorInstance) return;
    const contentArea = editorInstance.$el.get(0);
    if (!contentArea) return;
    const handleButtonClick = async (event) => {
      setActiveEditorId?.(event.target.name);
      const button = event.target.closest("button");
      const inputElement = button.previousElementSibling;
      setAnchorEl(inputElement)
      let response;
      if (!button) return;
      const buttonText = button.textContent.trim();
      const inputId = button.id.replace("dropdownButton", "").replace("dropdownIcon_", "");
      if (buttonText === "▾") {
        setCurrentInputId(`dropdown_${inputId}`);
        setIsDropdownLoading(true);
        event.stopPropagation();
        let dropDown;
        if (id === "introTextTE") {
          dropDown = (asArrayOrNull(editorDataRef.current?.dropdownList) || asArrayOrNull(editorData?.dropdownList))?.find((e) => e?.dropdown_uuid === inputId);
        } else if (type === "edit") {
          dropDown = asArrayOrNull(dropdownList)?.find((e) => e?.dropdown_uuid === inputId);
        }
        if (dropDown === undefined) {
          if (id === "commentText") dropDown = asArrayOrNull(commentData?.comment_dropdowns)?.find((e) => e?.dropdown_uuid === inputId);
          else if (id === "commentSummary" && commentData?.summary_comment_dropdowns?.length > 0) dropDown = asArrayOrNull(commentData?.summary_comment_dropdowns)?.find((e) => e?.dropdown_uuid === inputId);
          else {
            dropDown = (asArrayOrNull(editorDataRef.current?.dropdownList) || asArrayOrNull(editorData?.dropdownList))?.find((e) => e?.dropdown_uuid === inputId);
          }
        }
        let newDropdown;
        if (dropDown === undefined) dropDown = (asArrayOrNull(editorDataRef.current?.dropdownList) || asArrayOrNull(editorData?.dropdownList))?.find((e) => e?.dropdown_uuid === inputId);
        if (dropDown?.list_guid) {
          response = await dispatch(getGlobalListById(dropDown?.list_guid));
          if (response?.deleted_at) {
            const editorInstance = editor?.current?.editor;
            let editorContent = editorInstance?.html?.get();
            let newDropdownList = asArrayOrNull(editorDataRef.current?.dropdownList) || asArrayOrNull(editorData?.dropdownList) || asArrayOrNull((id === "commentText" || id === "nonNarrativeComment") ? commentData?.comment_dropdowns : commentData?.summary_comment_dropdowns) || [];
            let newIndex = newDropdownList?.findIndex((obj => obj?.list_guid === dropDown?.list_guid))
            newDropdownList[newIndex] = { ...newDropdownList[newIndex], list_guid: undefined, dropdowns_values: response?.options };
            if (id === "introTextTE" && setEditorContent) {
              onBlur?.(id, editorContent, newDropdownList[newIndex], "edit");
              handleDropdownList?.(id, newDropdownList);
              setEditorContent(prevState => ({ ...prevState, dropdownList: newDropdownList }));
            } else if (id === "commentText" && setEditorContent) {
              onBlur?.(id, editorContent, newDropdownList);
              setEditorContent(prevState => ({ ...prevState, commentText: { dropdownList: newDropdownList }, commentDropdownList: newDropdownList }));
            } else if (id === "commentSummary" && setEditorContent) {
              onBlur?.(id, editorContent, newDropdownList);
              setEditorContent(prevState => ({ ...prevState, commentSummary: { dropdownList: newDropdownList }, summaryDropdownList: newDropdownList }));
            } else if (id === "nonNarrativeComment") {
              onBlur?.(id, editorContent, newDropdownList);
              setEditorContent(prevState => ({ ...prevState, dropdownList: newDropdownList }));
            }
            setState((prevState) => ({ ...prevState, listGuid: undefined, listId: undefined, dialogOptionList: newDropdown?.dropdowns_values || [] }));
          }
        } else {
          const getFilteredDropdownValues = (dropdown) =>
            dropdown?.dropdowns_values?.filter(obj => !obj?.toUpperCase()?.includes("XXX")) || [];
          dropdownOptionListRef.current = (() => {
            if (event.target.name === "commentText") {
              return type === "edit"
                ? getFilteredDropdownValues(dropDown)
                : commentOptionList || [];
            }
            if (event.target.name === "commentSummary") {
              return getFilteredDropdownValues(dropDown);
            }
            return dropDown?.dropdowns_values?.length > 0
              ? getFilteredDropdownValues(dropDown)
              : [];
          })();
        }
        const options = (newDropdown?.dropdowns_values || response?.options || dropDown?.dropdowns_values)?.filter(obj => !obj?.toUpperCase()?.includes("XXX")) || [];
        setState(prev => ({ ...prev, dialogOptionList: options.length > 0 ? options : [] }));
        setCurrentInputId(`dropdown_${inputId}`);
        setIsDropdownLoading(false);
        setAnchorEl(button);
      }
      else if (buttonText === "✎") {
        event.stopPropagation();
        handleOpenDialog(event, null, id === "introTextTE" ? commentData?.introductory_text_dropdowns :
          (id === "commentText") ? commentData?.comment_dropdowns :
            (editorDataRef.current?.dropdownList || editorData?.dropdownList));
      }
    };
    const handleInputBlurWrapper = (event) => {
      if (event.target.tagName === "INPUT") {
        handleInputBlur(event, event.target.id, event.target.value);
      }
    };
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const buttons = node.querySelectorAll('button[id^="dropdownButton"], button[id^="dropdownIcon_"]');
            buttons.forEach(button => {
              button.addEventListener('click', handleButtonClick);
            });
            const inputs = node.querySelectorAll('input');
            inputs.forEach(input => {
              input.addEventListener('blur', handleInputBlurWrapper);
            });
          }
        });
      });
    });
    const buttons = contentArea.querySelectorAll('button[id^="dropdownButton"], button[id^="dropdownIcon_"]');
    buttons.forEach(button => {
      button.addEventListener('click', handleButtonClick);
    });
    const inputs = contentArea.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('blur', handleInputBlurWrapper);
    });
    observer.observe(contentArea, { childList: true, subtree: true });
    return () => {
      buttons.forEach(button => {
        button.removeEventListener('click', handleButtonClick);
      });
      inputs.forEach(input => {
        input.removeEventListener('blur', handleInputBlurWrapper);
      });
      observer.disconnect();
    };
  }, [editorData, commentData]);

  useEffect(() => {
    const handleDropdownDeleteClick = (event) => {
      if (event.target.id.startsWith("dropdownDelete")) {
        const dropdownId = event.target.id.replace("dropdownDelete", "");
        handleDeleteDropdown(dropdownId);
      }
    };
    document.addEventListener("click", handleDropdownDeleteClick);
    return () => {
      document.removeEventListener("click", handleDropdownDeleteClick);
    };
  }, []);

  const handleDeleteDropdown = (dropdownId) => {
    if (!dropdownId) return;
    const editorInstance = editor?.current?.editor;
    if (!editorInstance) return;
    editorInstance.undo.reset();
    // Parse HTML into DOM
    const wrapper = document.createElement("div");
    wrapper.innerHTML = editorInstance.html.get();
    // Find the exact dropdown span by ID
    const dropdownEl = wrapper.querySelector(`span[id="dropdown_${dropdownId}"], span[id="[dropdown ${dropdownId}]"]`);
    if (dropdownEl) dropdownEl.remove(); // Just remove the target dropdown
    // 🧼 Remove leftover &nbsp; characters around
    wrapper.innerHTML = wrapper.innerHTML.replace(/(&nbsp;|\u00A0)+/g, " ");
    // Set updated HTML back into the editor
    const cleaned = wrapper.innerHTML;
    editorInstance.html.set(cleaned);
    editorInstance.events.focus(true);
    editorInstance.undo.reset();
    setEditorContent(prevState => ({ ...prevState, innerHTML: cleaned }));
    // Filter dropdown from state
    let currentDropdownList =
      id === "introTextTE"
        ? commentData?.introductory_text_dropdowns
        : (id === "commentText" || id === "nonNarrativeComment")
          ? commentData?.comment_dropdowns
          : commentData?.summary_comment_dropdowns;
    const updatedDropdownList = currentDropdownList?.filter((item) => item?.dropdown_uuid !== dropdownId);
    setState((prev) => ({ ...prev, dropdownList: updatedDropdownList, }));
    if (id === "introTextTE") onBlur?.(id, cleaned, { dropdown_uuid: dropdownId }, "delete");
    else if ((id === "commentText" || id === "nonNarrativeComment") && setEditorContent) {
      onBlur?.(id, cleaned, updatedDropdownList);
      setEditorContent(prevState => ({ ...prevState, commentText: { innerHTML: cleaned, dropdownList: updatedDropdownList }, commentDropdownList: updatedDropdownList }));
    } else if (id === "commentSummary" && setEditorContent) {
      onBlur?.(id, cleaned, updatedDropdownList);
      setEditorContent(prevState => ({ ...prevState, commentSummary: { innerHTML: cleaned, dropdownList: updatedDropdownList }, summaryDropdownList: updatedDropdownList }));
    }
    handleDropdownList?.(id, updatedDropdownList);
  };

  useEffect(() => {
    window.openDropdown = (inputId, event) => {
      event.stopPropagation();
      event.preventDefault();
      const input = document.getElementById(inputId);
      if (!input) return;
      setCurrentInputId(inputId);
      const source =
        id === "introTextTE" ? (editorDataRef.current?.dropdownList || editorData?.dropdownList || []) :
          id === "commentText" ? (commentData?.comment_dropdowns || []) :
            id === "commentSummary" ? (commentData?.summary_comment_dropdowns || []) :
              (editorDataRef.current?.dropdownList || editorData?.dropdownList || []);
      const found = source.find(d => d?.dropdown_uuid === inputId);
      const list = (found?.dropdowns_values || [])
        .filter(v => !String(v).toUpperCase().includes("XXX"));
      dropdownOptionListRef.current = list;
      setState(prev => ({ ...prev, dialogOptionList: list }));
      setAnchorEl(input.nextElementSibling);
    };
    const bindDropdownEvents = () => {
      const dropdownInputs = document.querySelectorAll(".froala-dropdown-input");
      dropdownInputs.forEach((input) => {
        input.onclick = (event) => {
          event.preventDefault();
          setCurrentInputId(input.id);
          if (setActiveEditorId) setActiveEditorId(input.name)
        };
        input.oninput = (event) => {
          if (setActiveEditorId) setActiveEditorId(input.name)
          const value = event.target.value;
          input.value = value;
          input.setAttribute("value", value);
          input.setAttribute("title", value);
          const dropdownUuid = event.target.id?.replace(/^dropdown_/, "") ?? "";
          setState((prevState) => {
            const prevList = prevState.dropdownList?.length ? prevState.dropdownList : getDropdownListSource();
            const index = prevList.findIndex((obj) => obj?.dropdown_uuid === dropdownUuid);
            if (index === -1) return prevState;
            const oldValue = prevList[index]?.selected_value;
            if (oldValue === value) return prevState;
            const newList = [...prevList];
            newList[index] = {
              ...newList[index],
              selected_value: value || ""
            };
            return { ...prevState, dropdownList: newList, dialogOptionList: prevState.dialogOptionList };
          });
          if (setEditorContent && (id === "introTextTE" || id === "commentText" || id === "commentSummary")) {
            setEditorContent((prev) => {
              const prevList =
                id === "commentText"
                  ? (prev.commentDropdownList?.length ? prev.commentDropdownList : getDropdownListSource())
                  : id === "commentSummary"
                    ? (prev.summaryDropdownList?.length ? prev.summaryDropdownList : getDropdownListSource())
                    : (prev?.dropdownList?.length ? prev.dropdownList : getDropdownListSource());
              const index = prevList.findIndex((obj) => obj?.dropdown_uuid === dropdownUuid);
              if (index === -1) return prev;
              const newList = [...prevList];
              newList[index] = { ...newList[index], selected_value: value || "" };
              if (id === "commentText") {
                return {
                  ...prev,
                  commentDropdownList: newList,
                  commentText: { ...(prev.commentText || {}), dropdownList: newList },
                };
              }
              if (id === "commentSummary") {
                return {
                  ...prev,
                  summaryDropdownList: newList,
                  commentSummary: { ...(prev.commentSummary || {}), dropdownList: newList },
                };
              }
              return { ...prev, dropdownList: newList };
            });
            handleDropdownList?.(id, (() => {
              const prevList = getDropdownListSource();
              const index = prevList.findIndex((obj) => obj?.dropdown_uuid === dropdownUuid);
              if (index === -1) return prevList;
              const newList = [...prevList];
              newList[index] = { ...newList[index], selected_value: value || "" };
              return newList;
            })());
          }
        };
      });
    };
    const cleanupRemovedInputs = () => {
      const dropdownInputs = document.querySelectorAll(".froala-dropdown-input");
      const activeIds = new Set(Array.from(dropdownInputs).map((input) => input.id));
      if (currentInputId && !activeIds.has(currentInputId)) {
        // setCurrentInputId(null);
        setAnchorEl(null);
      }
    };
    bindDropdownEvents();
    cleanupRemovedInputs();
    window.bindDropdownEvents = bindDropdownEvents;
    window.cleanupRemovedInputs = cleanupRemovedInputs;
    const observer = new MutationObserver(() => {
      bindDropdownEvents();
      cleanupRemovedInputs();
    });
    const froalaEditor = document.querySelector(".fr-element");
    if (froalaEditor) {
      observer.observe(froalaEditor, { childList: true, subtree: true });
    }
    return () => observer.disconnect();
  }, [commentOptionList, dialogOptionList, summaryOptionList, commentData]);

  

  const handleSelect = (value) => {
    if (!currentInputId) return;
    const dropdownUuid = getDropdownUuidFromInputId(currentInputId);
    const inputElement = document.getElementById(currentInputId);
    if (inputElement) {
      inputElement.value = value?.replace(/"/g, '&quot;');
    }
    const editorInstance = editor?.current?.editor;
    let newContent;
    setTimeout(() => {
      if (editorInstance) {
        newContent = editorInstance.html.get()?.replace(
          new RegExp(`(<input[\\s\\S]*?id=["']${currentInputId}["'][\\s\\S]*?value=["'])([\\s\\S]*?)(["'])`, 'i'), `$1${value.replace(/"/g, '&quot;')}$3`
        );
        editorInstance.html.set(newContent);
        editorInstance.events.trigger('contentChanged');
        const editorRoot = editorInstance?.$el?.get(0);
        if (editorRoot) {
          editorInstance.selection.setAtEnd(editorRoot);
          editorInstance.selection.restore();
        }
      }
      let updatedDropdownList = [];
      if (type === "edit" && handleChangeDropdown) {
        handleChangeDropdown(inputElement.value, dropdownUuid, id === "commentText" ? "comment" : "summary", null, null);
      } else if (id === "introTextTE") {
        setEditorContent((prevState) => {
          const base = resolveDropdownList({
            prevList: prevState.dropdownList,
            editorList: editorData?.dropdownList,
            localList: dropdownList,
          });
          updatedDropdownList = updateDropdownSelection(base, dropdownUuid, value);
          return { ...prevState, innerHTML: newContent, dropdownList: updatedDropdownList };
        });
        onBlur?.(id, newContent, { dropdown_uuid: dropdownUuid, selected_value: value }, "edit");
        handleDropdownList?.(id, updatedDropdownList, "select");
        setState((prev) => ({ ...prev, dropdownList: updatedDropdownList }));
      } else if (id === "commentText") {
        setEditorContent((prevState) => {
          const base = resolveDropdownList({
            prevList: prevState.commentDropdownList,
            editorList: prevState.commentText?.dropdownList ?? editorData?.dropdownList,
            commentDropdowns: commentData?.comment_dropdowns,
            localList: dropdownList,
          });
          updatedDropdownList = updateDropdownSelection(base, dropdownUuid, value);
          return {
            ...prevState,
            commentText: { ...prevState.commentText, innerHTML: newContent, dropdownList: updatedDropdownList },
            commentDropdownList: updatedDropdownList,
          };
        });
        onBlur?.(id, newContent, updatedDropdownList);
        handleDropdownList?.(id, updatedDropdownList, "select");
        setState((prev) => ({ ...prev, dropdownList: updatedDropdownList }));
      } else if (id === "commentSummary") {
        setEditorContent((prevState) => {
          const base = resolveDropdownList({
            prevList: prevState.summaryDropdownList,
            editorList: prevState.commentSummary?.dropdownList ?? editorData?.dropdownList,
            commentDropdowns: commentData?.summary_comment_dropdowns,
            localList: dropdownList,
          });
          updatedDropdownList = updateDropdownSelection(base, dropdownUuid, value);
          return {
            ...prevState,
            commentSummary: { ...prevState.commentSummary, innerHTML: newContent, dropdownList: updatedDropdownList },
            summaryDropdownList: updatedDropdownList,
          };
        });
        onBlur?.(id, newContent, updatedDropdownList);
        handleDropdownList?.(id, updatedDropdownList, "select");
        setState((prev) => ({ ...prev, dropdownList: updatedDropdownList }));
      } else if (id === "nonNarrativeComment") {
        setEditorContent((prevState) => {
          const base = resolveDropdownList({
            prevList: prevState.dropdownList,
            editorList: editorData?.dropdownList,
            localList: dropdownList,
          });
          updatedDropdownList = updateDropdownSelection(base, dropdownUuid, value);
          return { ...prevState, innerHTML: newContent, dropdownList: updatedDropdownList };
        });
        setState((prev) => ({ ...prev, dropdownList: updatedDropdownList }));
      }
    }, 10);
    setAnchorEl(null);
  };
  const isDropdownListItemEffectivelyEmpty = (listItem) =>
    !listItem?.innerHTML?.replace(/&nbsp;|<br\s*\/?>/gi, "").trim();

  const dropdownListItemFromListElement = (listEl) => {
    if (!listEl?.matches?.("ol, ul")) return null;
    const items = listEl.querySelectorAll(":scope > li");
    if (!items.length) return null;
    const emptyLi = [...items].reverse().find(isDropdownListItemEffectivelyEmpty);
    return emptyLi || items[items.length - 1];
  };

  const getDropdownListItemFromRange = (range) => {
    if (!range) return null;
    let node = range.startContainer;
    if (node?.nodeType === Node.TEXT_NODE) node = node.parentElement;
    return node?.closest?.("li") || null;
  };
  const resolveDropdownTargetListItem = (editorRoot, range, editorInstance) => {
    const fromRange = getDropdownListItemFromRange(range);
    if (fromRange && editorRoot?.contains(fromRange)) return fromRange;

    try {
      const selEl = editorInstance?.selection?.element?.();
      const fromSelection = selEl?.closest?.("li");
      if (fromSelection && editorRoot?.contains(fromSelection)) return fromSelection;
    } catch (_) { /* no-op */ }

    if (!range || !editorRoot) return null;

    const { startContainer, startOffset } = range;
    const tryAdjacentList = (node) => dropdownListItemFromListElement(node);

    if (startContainer === editorRoot || startContainer?.classList?.contains?.("fr-element")) {
      return (
        tryAdjacentList(startContainer.childNodes[startOffset - 1]) ||
        tryAdjacentList(startContainer.childNodes[startOffset])
      );
    }

    if (startContainer.nodeType === Node.ELEMENT_NODE) {
      const fromChild = tryAdjacentList(startContainer.childNodes[startOffset - 1]);
      if (fromChild) return fromChild;
    }

    if (startContainer.nodeType === Node.TEXT_NODE) {
      let sib = startContainer.previousSibling;
      while (sib) {
        const li = tryAdjacentList(sib);
        if (li) return li;
        if (sib.nodeType === Node.ELEMENT_NODE && !sib.matches?.("ol, ul")) break;
        sib = sib.previousSibling;
      }
    }

    return null;
  };

  const insertDropdownWrapperInListItem = (listItem, wrapperEl, insertRange, editorInstance) => {
    const spaceNode = document.createTextNode(" ");

    if (isDropdownListItemEffectivelyEmpty(listItem)) {
      listItem.innerHTML = "";
    }

    const lastWrapperInLi = listItem.querySelector(
      ".froala-dynamic-input-wrapper:last-of-type, .froala-dropdown-wrapper:last-of-type"
    );

    if (
      insertRange &&
      listItem.contains(insertRange.startContainer) &&
      document.contains(insertRange.startContainer)
    ) {
      insertRange.collapse(true);
      insertRange.insertNode(wrapperEl);
      wrapperEl.after(spaceNode);
    } else if (lastWrapperInLi) {
      const afterWrapperRange = document.createRange();
      const nextSib = lastWrapperInLi.nextSibling;
      if (nextSib?.nodeType === Node.TEXT_NODE) {
        afterWrapperRange.setStart(nextSib, nextSib.textContent.length);
      } else {
        afterWrapperRange.setStartAfter(lastWrapperInLi);
      }
      afterWrapperRange.collapse(true);
      afterWrapperRange.insertNode(wrapperEl);
      wrapperEl.after(spaceNode);
    } else {
      listItem.appendChild(wrapperEl);
      listItem.appendChild(spaceNode);
    }
    editorInstance.events.trigger("contentChanged");
    placeCaretInEditorAt(spaceNode, listItem);
    return wrapperEl;
  };

  const relocateDropdownWrapperIntoAdjacentList = (wrapper, editorRoot) => {
    if (!wrapper || !editorRoot || wrapper.closest("li")) return false;

    let listEl = null;
    let sib = wrapper.previousSibling;
    while (sib) {
      if (sib.nodeType === Node.ELEMENT_NODE && (sib.matches("ol") || sib.matches("ul"))) {
        listEl = sib;
        break;
      }
      sib = sib.previousSibling;
    }

    const listItem = dropdownListItemFromListElement(listEl);
    if (!listItem) return false;

    if (isDropdownListItemEffectivelyEmpty(listItem)) {
      listItem.innerHTML = "";
    }

    listItem.appendChild(wrapper);
    const next = wrapper.nextSibling;
    if (!(next?.nodeType === Node.TEXT_NODE && /^[\s ]*$/.test(next.textContent))) {
      wrapper.after(document.createTextNode(" "));
    }
    return true;
  };

  const finalizeDropdownWrapperPlacement = (elementId, wrapperSelector, editorInstance, editorRoot, targetListItem) => {
    const newlyInserted = editorRoot.querySelector(`#${CSS.escape(elementId)}`);
    if (!newlyInserted) return null;

    const newWrapper = newlyInserted.closest(wrapperSelector);
    if (!newWrapper) return null;

    if (!newWrapper.closest("li")) {
      if (relocateDropdownWrapperIntoAdjacentList(newWrapper, editorRoot)) {
        editorInstance.events.trigger("contentChanged");
      }
    }

    const parentEl = newWrapper.parentElement;
    if (parentEl?.tagName === "P") {
      const liParent = parentEl.closest("li");
      if (liParent) {
        liParent.insertBefore(newWrapper, parentEl);
        liParent.insertBefore(document.createTextNode(" "), parentEl);
        const pContent = parentEl.innerHTML.replace(/&nbsp;|<br\s*\/?>/gi, "").trim();
        if (!pContent) parentEl.remove();
      } else if (targetListItem && editorRoot.contains(targetListItem) && !targetListItem.contains(newWrapper)) {
        if (isDropdownListItemEffectivelyEmpty(targetListItem)) targetListItem.innerHTML = "";
        targetListItem.appendChild(newWrapper);
        targetListItem.appendChild(document.createTextNode(" "));
        const orphanP = newWrapper.parentElement?.tagName === "P" ? newWrapper.parentElement : null;
        if (orphanP) {
          const orphanContent = orphanP.innerHTML.replace(/&nbsp;|<br\s*\/?>/gi, "").trim();
          if (!orphanContent) orphanP.remove();
        }
      }
    } else if (!newWrapper.closest("li")) {
      if (relocateDropdownWrapperIntoAdjacentList(newWrapper, editorRoot)) {
        editorInstance.events.trigger("contentChanged");
      }
    }

    return newWrapper;
  };

  const addDropdown = (e, list) => {
    e.stopPropagation();
    e.preventDefault();
    const target = e?.target;
    const grandParent = target?.parentElement?.parentElement?.parentElement;
    const grandParentPrevSibling = grandParent?.previousElementSibling;
    if (setActiveEditorId) setActiveEditorId(grandParentPrevSibling?.id || id);
    const editorInstance = editor.current.editor;
    const editorRoot = editorInstance.$el.get(0);
    const savedRange = savedRangeRef.current;

    const anchorWrapperCandidate =
      lastFocusedDropdownRef.current ||
      lastFocusedDynamicWrapperRef.current ||
      document.activeElement?.closest?.('span[id^="dropdown_"]') ||
      document.activeElement?.closest?.('.froala-dynamic-input-wrapper');

    const anchorWrapper = anchorWrapperCandidate && document.contains(anchorWrapperCandidate)
      ? anchorWrapperCandidate
      : null;

    if (anchorWrapper) {
      editorRoot.focus();
      lastFocusedDropdownRef.current = null;
      lastFocusedDynamicWrapperRef.current = null;

      if (anchorWrapper.parentNode) {
        const afterRange = document.createRange();
        let rangeSet = false;
        const nextSibling = anchorWrapper.nextSibling;
        if (nextSibling && nextSibling.nodeType === Node.TEXT_NODE && nextSibling.parentNode) {
          afterRange.setStart(nextSibling, nextSibling.textContent.length);
          rangeSet = true;
        } else if (anchorWrapper.parentNode) {
          afterRange.setStartAfter(anchorWrapper);
          rangeSet = true;
        }
        if (rangeSet) {
          afterRange.collapse(true);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(afterRange);
          savedRangeRef.current = afterRange.cloneRange();
        }
      }
    } else {
      editorRoot.focus();
      const savedContainer = savedRange?.commonAncestorContainer;
      if (
        savedRange &&
        savedContainer &&
        editorRoot.contains(savedContainer) &&
        document.contains(savedContainer)
      ) {
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(savedRange);
      } else {
        editorInstance.selection.restore();
      }
    }
    const selection = editorInstance.selection.get();
    if (!selection) return;
    const selectedNode = selection.startContainer || selection.commonAncestorContainer;
    const dropdownAncestor = editorInstance.$(selectedNode).closest('span[id^="dropdown_"]')[0];
    if (dropdownAncestor) {
      const range = editorInstance.selection.ranges(0);
      if (range) {
        const afterNode = document.createTextNode("\u00A0"); // add space to separate
        dropdownAncestor.parentNode.insertBefore(afterNode, dropdownAncestor.nextSibling);
        range.setStartAfter(afterNode);
        range.setEndAfter(afterNode);
        editorInstance.selection.setRange(range);
      }
    }
    const newDropdownList = [...getDropdownListSource()];
    
    const newSelectUuid = uuid();
    const html = editorInstance.html.get();
    if (html.trim() === "<p><br></p>") {
      editorInstance.html.set("");
    }
    const dropdownHtml =
      ` <span contenteditable="false" id="dropdown_${newSelectUuid}" class="froala-dropdown-wrapper" style="display: inline-flex; align-items: center; vertical-align: middle; line-height: normal;">
         <input
            type="text"
            class="froala-dropdown-input"
            id="dropdown_${newSelectUuid}"
            name="${grandParentPrevSibling?.id || id}"
            value=""
            placeholder="Type or select from dropdown"
            style="
              width: 220px;
              background-color: #f1f9fe;
              height: 23px;
              padding: 4px 8px;
              vertical-align: middle;
              border-top: 1px solid #4282e2;
              border-bottom: 1px solid #4282e2;
              border-left: 1px solid #4282e2;
              border-right: none;
              border-radius: 4px 0 0 4px;
              font-size: 14px;
              font-weight: 600;
              color: #3B3B3B;
              cursor: text;
              text-align: left;
            "
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
          />
          <button
            type="button"
            id="dropdownIcon_${newSelectUuid}"
            name="${grandParentPrevSibling?.id || id}"
            data-dropdown-id="${newSelectUuid}"
            onclick="window.openDropdown('dropdown_${newSelectUuid}', event)"
            style="
              background-color: #f1f9fe;
              width: 26px;
              height: 23px;
              border: 1px solid #4282e2;
              border-right: 0;
              margin-left: -4px;
              font-size: 14px;
              color: #4282e2;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              padding-right: 3px;
              cursor: pointer;
            "
          >▾</button>
          <button
            id="dropdownButton${newSelectUuid}"
            name="${grandParentPrevSibling?.id || id}"
            style="
              background-color: #f1f9fe;
              width: 24px;
              height: 23px;
              border: 1px solid #4282e2;
              border-radius: 0 4px 4px 0;
              margin-left: -4px;
              font-size: 14px;
              color: #4282e2;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            "
          >✎</button>
        </span>&nbsp;`;
    // Insert at the caret via a DOM range (same mechanism as "Add input") instead of
    // editorInstance.html.insert(). Froala's html.insert wraps inserted content in its
    // default block tag, which is undefined inside <li> and makes the dropdown land at
    // the start of the editor rather than inline at the cursor.
    const rangeForListInsert = (() => {
      const sel = window.getSelection();
      if (sel?.rangeCount > 0) {
        const r = sel.getRangeAt(0);
        if (editorRoot.contains(r.commonAncestorContainer)) return r.cloneRange();
      }
      if (savedRange && editorRoot.contains(savedRange.commonAncestorContainer)) {
        return savedRange.cloneRange();
      }
      return null;
    })();
    const dropdownTargetListItem = resolveDropdownTargetListItem(editorRoot, rangeForListInsert, editorInstance);

    let dropdownInserted = false;
    if (dropdownTargetListItem && editorRoot.contains(dropdownTargetListItem)) {
      const temp = document.createElement("div");
      temp.innerHTML = dropdownHtml.trim();
      const wrapperEl = temp.firstElementChild;
      if (wrapperEl) {
        insertDropdownWrapperInListItem(dropdownTargetListItem, wrapperEl, rangeForListInsert, editorInstance);
        dropdownInserted = !!editorRoot.querySelector(`#dropdown_${newSelectUuid}`);
      }
    }
    if (!dropdownInserted) {
      dropdownInserted =
        insertDynamicInputAtCursor(editorInstance, dropdownHtml) ||
        appendDynamicInputAtEditorEnd(editorInstance, dropdownHtml);
    }
    if (!dropdownInserted) {
      editorInstance.selection.setAtEnd(editorRoot);
      editorInstance.selection.restore();
      dropdownInserted =
        insertDynamicInputAtCursor(editorInstance, dropdownHtml) ||
        appendDynamicInputAtEditorEnd(editorInstance, dropdownHtml);
    }
    if (dropdownTargetListItem && editorRoot.contains(dropdownTargetListItem)) {
      finalizeDropdownWrapperPlacement(
        `dropdown_${newSelectUuid}`,
        ".froala-dropdown-wrapper",
        editorInstance,
        editorRoot,
        dropdownTargetListItem
      );
    }
    const insertedDropdown = editorRoot.querySelector(
      `span.froala-dropdown-wrapper[id="dropdown_${newSelectUuid}"]`
    );
    if (insertedDropdown) {
      // Remove Froala's filler <br> that precedes the non-editable dropdown span,
      // otherwise the dropdown is pushed onto a new line inside the list item.
      let prevNode = insertedDropdown.previousSibling;
      while (prevNode && prevNode.nodeName === "BR") {
        const toRemove = prevNode;
        prevNode = prevNode.previousSibling;
        toRemove.remove();
      }
      // Keep an editable separator directly after the dropdown within the same block,
      // so Froala doesn't treat the paragraph as empty and re-insert a leading <br>.
      const nextNode = insertedDropdown.nextSibling;
      if (!(nextNode && nextNode.nodeType === Node.TEXT_NODE && /\u00A0/.test(nextNode.textContent))) {
        insertedDropdown.parentNode?.insertBefore(
          document.createTextNode("\u00A0"),
          insertedDropdown.nextSibling
        );
      }
    }
    window.bindDropdownEvents?.();
    window.cleanupRemovedInputs?.();
    let newDropodwnObj = {
      dropdown_uuid: newSelectUuid,
      name: list?.name || "",
      selected_value: "",
      dropdowns_values: list?.options,
    }
    if (list?.list_guid || open === "global_lists" || (saveToGlobalLists && open === "new_list")) newDropodwnObj.list_guid = list?.list_guid;
    newDropdownList?.push(newDropodwnObj);
    setState((prevState) => ({ ...prevState, dropdownList: newDropdownList }));
    if (setIsButtonAdded) setIsButtonAdded(true);
    let updatedHtml = editorInstance.html.get();
    updatedHtml = updatedHtml.replace(/<p>\s*<br\s*\/?>\s*<\/p>/gi, '');
    if (id === "introTextTE" && setEditorContent) {
      onBlur?.(id, updatedHtml, newDropodwnObj, "add");
      handleDropdownList?.(id, newDropdownList);
      setEditorContent(prevState => ({ ...prevState, innerHTML: updatedHtml, dropdownList: newDropdownList }));
    } else if (id === "commentText" && setEditorContent) {
      onBlur?.(id, updatedHtml, newDropdownList);
      setEditorContent(prevState => ({ ...prevState, commentText: { innerHTML: updatedHtml, dropdownList: newDropdownList }, commentDropdownList: newDropdownList }));
    } else if (id === "commentSummary" && setEditorContent) {
      onBlur?.(id, updatedHtml, newDropdownList);
      setEditorContent(prevState => ({ ...prevState, commentSummary: { innerHTML: updatedHtml, dropdownList: newDropdownList }, summaryDropdownList: newDropdownList }));
    } else if (id === "nonNarrativeComment") {
      onBlur?.(id, updatedHtml, newDropdownList);
      setEditorContent(prevState => ({ ...prevState, innerHTML: updatedHtml, dropdownList: newDropdownList }));
    }
  };
  const addInput = (e) => {
    e.preventDefault();
    e.stopPropagation();
  
    const editorInstance = editor.current?.editor;
  
    if (!editorInstance) return;
  
    // Check tracked ref first, fall back to activeElement (covers the initial focus case).
    // Anchor after a focused dropdown wrapper, or after a focused dynamic input wrapper
    // (so consecutive "Add input" clicks insert after the previously added input).
    const anchorWrapperCandidate =
      lastFocusedDropdownRef.current ||
      lastFocusedDynamicWrapperRef.current ||
      document.activeElement?.closest?.('span[id^="dropdown_"]') ||
      document.activeElement?.closest?.('.froala-dynamic-input-wrapper');
  
    // Only use the candidate if it is still attached to the live DOM; after a
    // previous insert Froala may have replaced the node, leaving the ref stale.
    const anchorWrapper = anchorWrapperCandidate && document.contains(anchorWrapperCandidate)
      ? anchorWrapperCandidate
      : null;
  
    let selectionPlaced = false;
  
    if (anchorWrapper) {
      // Focus the editor first so window.getSelection is inside the contenteditable.
      // NOTE: focus() dispatches synchronous blur/focus events; those can trigger
      // html.set() which replaces editor DOM nodes and detaches anchorWrapper.
      // We therefore re-check parentNode immediately before every range call.
      editorInstance.$el.get(0).focus();
      lastFocusedDropdownRef.current = null;
      lastFocusedDynamicWrapperRef.current = null;
  
      if (anchorWrapper.parentNode) {
        const afterRange = document.createRange();
        let rangeSet = false;
        // Place the caret AFTER the wrapper's trailing whitespace (the "&nbsp;" separator),
        // otherwise each new "</span>&nbsp;" inserts before existing spaces and all the
        // separators pile up at the end.
        const nextSibling = anchorWrapper.nextSibling;
        if (nextSibling && nextSibling.nodeType === Node.TEXT_NODE && nextSibling.parentNode) {
          afterRange.setStart(nextSibling, nextSibling.textContent.length);
          rangeSet = true;
        } else if (anchorWrapper.parentNode) {
          afterRange.setStartAfter(anchorWrapper);
          rangeSet = true;
        }
        if (rangeSet) {
          afterRange.collapse(true);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(afterRange);
          selectionPlaced = true;
        }
      }
    } else if (savedRangeRef.current) {
      // Only restore the saved range if its container is still in the live DOM.
      // After an html.set() call (e.g. from a categoryData effect in AddIntroText)
      // all editor nodes are replaced, leaving the cloned range pointing to
      // detached nodes. Passing such a range to html.insert causes Froala to call
      // setStartAfter on an orphaned node, which throws.
      const savedContainer = savedRangeRef.current.commonAncestorContainer;
      if (savedContainer && document.contains(savedContainer)) {
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(savedRangeRef.current);
        selectionPlaced = true;
      }
    }
  
    if (!selectionPlaced) {
      editorInstance.$el.get(0).focus();
      // Prefer inserting after the last existing wrapper (same inline context) so
      // Froala doesn't wrap the new span in a fresh <p>.  Only fall back to
      // setAtEnd when there are no wrappers at all.
      const editorRoot = editorInstance.$el.get(0);
      const allWrappers = editorRoot.querySelectorAll('.froala-dynamic-input-wrapper');
      const lastWrapper = allWrappers.length ? allWrappers[allWrappers.length - 1] : null;
      if (lastWrapper && lastWrapper.parentNode) {
        const fallbackRange = document.createRange();
        const nextSib = lastWrapper.nextSibling;
        if (nextSib && nextSib.nodeType === Node.TEXT_NODE && nextSib.parentNode) {
          fallbackRange.setStart(nextSib, nextSib.textContent.length);
        } else {
          fallbackRange.setStartAfter(lastWrapper);
        }
        fallbackRange.collapse(true);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(fallbackRange);
      } else {
        editorInstance.selection.setAtEnd(editorInstance.$el.get(0));
        editorInstance.selection.restore();
      }
    }
  
    const newInputUuid = uuid();
    const inputHtml =
      `<span contenteditable="false" class="froala-dynamic-input-wrapper" style="display:inline;vertical-align:baseline;line-height:normal;"><input id="${newInputUuid}" type="text" value="" title="" style="width:104px;background-color:#f1f9fe;height:24px !important;overflow-wrap:break-word;padding:1px 17px 3px 6px;border-radius:4px;border:1px solid #0F75BC;appearance:none;-webkit-appearance:none;-moz-appearance:none;font-size:14px;color:#3B3B3B;font-style:normal;font-weight:600;max-width:200px;min-width:104px;text-overflow:ellipsis;margin-left:2px;white-space:nowrap;vertical-align:baseline;"/></span>`;

    // Never use editorInstance.html.insert here — Froala wraps content in
    // html.defaultTag(), which is undefined inside list items and produces
    // invalid <undefined><br></undefined> nodes.
    let inserted =
      insertDynamicInputAtCursor(editorInstance, inputHtml) ||
      appendDynamicInputAtEditorEnd(editorInstance, inputHtml);

    if (!inserted) {
      editorInstance.selection.setAtEnd(editorInstance.$el.get(0));
      editorInstance.selection.restore();
      inserted =
        insertDynamicInputAtCursor(editorInstance, inputHtml) ||
        appendDynamicInputAtEditorEnd(editorInstance, inputHtml);
    }

    const editorRoot = editorInstance.$el.get(0);
    const newlyInsertedInput = editorRoot.querySelector(`[id="${newInputUuid}"]`);
    if (newlyInsertedInput) {
      normalizeDynamicInputWrapperPlacement(
        newlyInsertedInput.closest(".froala-dynamic-input-wrapper"),
        editorRoot
      );
      normalizeDynamicInputSeparators(editorRoot);
      sanitizeInvalidEditorNodes(editorRoot);
    }
  
    // State updates
    setIsFocused?.(true);
    setHasChanges?.(true);
    setIsButtonAdded?.(true);
  
    const updatedDropdownList = persistDynamicInputValues(
      editorInstance,
      getDropdownListSource()
    );
    const editorContent = editorInstance.html.get();

    syncEditorStateWithDropdowns(editorContent, updatedDropdownList);
    onChange?.(id, editorContent);

    handleIntroSave?.();
  
    // Focus input and attach listeners after DOM update
    requestAnimationFrame(() => {
      const inputEl = document.getElementById(newInputUuid);
      const editorRoot = editorInstance.$el?.get(0);

      if (!inputEl) return;

      inputEl.focus({ preventScroll: true });
      inputEl.select();

      const handleChange = (event) => {
        event.target.setAttribute("value", event.target.value);
        event.target.setAttribute("title", event.target.value);
        editor.current?.editor?.events.trigger("contentChanged");
        document.dispatchEvent(
          new CustomEvent("changeInput", {
            detail: { id: newInputUuid, value: event.target.value },
          })
        );
        const updatedContent = editor.current?.editor?.html.get();
        const updatedDropdownList = persistDynamicInputValues(
          editor.current?.editor,
          getDropdownListSource()
        );
        onChange?.(id, updatedContent);
        syncEditorStateWithDropdowns(updatedContent, updatedDropdownList);
      };

       
      const handleKeydown = (keyEvent) => {
        if (keyEvent.key === 'Enter') {
          const wrapper = getDynamicInputWrapper(inputEl);
          if (wrapper && editorRoot?.contains(wrapper)) {
            keyEvent.preventDefault();
            keyEvent.stopImmediatePropagation();
            inputEl.blur();
            editorRoot.focus();
            let liveWrapper = wrapper;
            if (!document.contains(liveWrapper) || !liveWrapper.parentNode) {
              const freshInput = document.getElementById(newInputUuid);
              liveWrapper = freshInput ? getDynamicInputWrapper(freshInput) : null;
            }
            const sel = liveWrapper && liveWrapper.parentNode ? window.getSelection() : null;
            if (sel) {
              const newRange = document.createRange();
              const trailingSeparator =
                liveWrapper.nextSibling &&
                liveWrapper.nextSibling.nodeType === Node.TEXT_NODE &&
                liveWrapper.nextSibling.parentNode
                  ? liveWrapper.nextSibling
                  : null;
              if (trailingSeparator) {
                newRange.setStart(trailingSeparator, trailingSeparator.textContent.length);
              } else {
                liveWrapper.after(document.createTextNode(" "));
                newRange.setStart(liveWrapper.nextSibling, 1);
              }
              newRange.collapse(true);
              sel.removeAllRanges();
              sel.addRange(newRange);
              savedRangeRef.current = newRange.cloneRange();
            }
          }
          return;
        }
        if (keyEvent.key !== 'Backspace' && keyEvent.key !== 'Delete') return;
        const wrapper = getDynamicInputWrapper(inputEl);
        if (!wrapper) return;

        const value = inputEl.value ?? '';
        const start = inputEl.selectionStart ?? 0;
        const end = inputEl.selectionEnd ?? 0;

        if (keyEvent.key === 'Backspace') {
          if (value !== '' && start > 0 && start === end) return;
        } else if (value !== '' && end < value.length && start === end) {
          return;
        }
        if (value !== '' && start !== end) return;

        keyEvent.preventDefault();
        keyEvent.stopImmediatePropagation();
        removeDynamicInputWrapper(wrapper);
      };
  
      ensureDynamicInputObserver(editorRoot);
      bindDynamicInputRemovalKeydownHandler(editorRoot);
      registerDynamicInputListeners(inputEl, newInputUuid, handleKeydown, handleChange);
    });
  };

  const updateDropdownContent = (newDropdownOptions, replacedContent, newDialogOptionList, listGuid) => {
    const editorInstance = editor?.current?.editor;
    if (setEditorContent && id === "introTextTE") {
      onBlur?.(id, replacedContent, { dropdown_uuid: selectedDropdown, dropdowns_values: newDialogOptionList, list_guid: listGuid }, "edit");
      handleDropdownList?.(id, newDropdownOptions);
      setEditorContent(prevState => ({ ...prevState, innerHTML: replacedContent, dropdownList: newDropdownOptions }));
    } else if (id === "commentSummary") {
      onBlur?.(id, replacedContent, newDropdownOptions);
      if (setEditorContent) setEditorContent(prevState => ({
        ...prevState,
        commentSummary: { innerHTML: replacedContent, dropdownList: newDropdownOptions },
        summaryDropdownList: newDropdownOptions
      }));
      else {
        handleDropdownList?.(id, newDropdownOptions);
        onChange?.(id, editorInstance.html.get());
      }
    } else if (id === "nonNarrativeComment") {
      onBlur?.(id, replacedContent, newDropdownOptions);
      if (setEditorContent) setEditorContent(prevState => ({ ...prevState, innerHTML: replacedContent, dropdownList: newDropdownOptions }));
    } else {
      onBlur?.(id, replacedContent, newDropdownOptions);
      if (setEditorContent) setEditorContent(prevState => ({
        ...prevState,
        commentText: { innerHTML: replacedContent, dropdownList: newDropdownOptions },
        commentDropdownList: newDropdownOptions
      }));
      if (type !== "edit" && setCommentOptionList) setCommentOptionList(newDialogOptionList);
      else {
        handleDropdownList?.(id, newDropdownOptions);
        onChange?.(id, editorInstance.html.get());
      }
    }
  }
  const resetState = (newDropdownOptions = [], newDialogOptionList = []) => {
    setState(p => ({
      ...p,
      name: "",
      open: false,
      description: "",
      tags: [],
      dialogOptionList: newDialogOptionList,
      saveToGlobalLists: false,
      newOption: "",
      textfield: false,
      editedOption: null,
      dropdownList: Array.isArray(newDropdownOptions) && newDropdownOptions.length ? newDropdownOptions : p.dropdownList,
      summaryOptionList: [],
      listId: null,
      listGuid: null
    }));
  }
  const handleSave = (event) => {
    event?.stopPropagation();
    const filteredDialogOptionList = (dialogOptionList || [])
      .map(option => (option || "").toString().trim())
      .filter(option => option !== "" && option !== null && option !== undefined);
    const editorInstance = editor?.current?.editor;
    let editorContent = editorInstance?.html?.get();
    const newDialogOptionList = filteredDialogOptionList;
    const updateCurrentDropdown = (newId) => {
      const inputId = selectedDropdown?.replace("dropdownButton", "").replace("dropdownIcon_", "");
      let newDropdownOptions =
        Array.isArray(dropdownList) && dropdownList.length
          ? [...dropdownList]
          : id === "introTextTE"
            ? (Array.isArray(commentData?.introductory_text_dropdowns) ? commentData.introductory_text_dropdowns : [])
            : (Array.isArray(editorData?.dropdownList) ? editorData.dropdownList : []);
      let index = newDropdownOptions?.findIndex((obj) => obj?.dropdown_uuid === inputId);
      if (index === -1) index = dropdownList?.findIndex((obj) => obj?.isPasted === true);
      if (newDropdownOptions.length === 0) {
        newDropdownOptions.push({
          list_guid: newId || undefined,
          dropdown_uuid: newId || inputId,
          selected_value: "",
          dropdowns_values: newDialogOptionList?.length === 0 ? [] : newDialogOptionList
        });
      } else {
        newDropdownOptions[index] = {
          ...newDropdownOptions[index],
          list_guid: newId || undefined,
          dropdowns_values: newDialogOptionList || [],
        };
      }
      return { newDropdownOptions, editorContent, newDialogOptionList };
    };
    if (!saveToGlobalLists && open === "new_list") {
      addDropdown(event, { options: filteredDialogOptionList });
      setState((prevState) => ({ ...prevState, name: "", open: false, description: "", tags: [], dialogOptionList: [] }));
    } else if (open === "edit_list" && saveToGlobalLists) {
      const newId = uuid();
      const data = {
        options: filteredDialogOptionList,
        list_guid: listGuid || newId,
        name: name?.length > 255 ? name?.slice(0, 255) : name,
        description: description,
        tag_ids: tags
      }
      if (listGuid) {
        dispatch(editGlobalList({ ...data, tag_ids: tags?.map((tag) => tag?.pivot?.tag_id || tag?.id) }));
        resetState();
      }
      else {
        dispatch(addGlobalList({ ...data, tag_ids: tags?.map((tag) => tag?.pivot?.tag_id || tag?.id) }));
        const { newDropdownOptions, editorContent, newDialogOptionList } = updateCurrentDropdown(newId);
        updateDropdownContent(newDropdownOptions, editorContent, newDialogOptionList, newId);
        resetState(newDropdownOptions, newDialogOptionList);
      }
    } else if (saveToGlobalLists) {
      const newId = uuid();
      const data = {
        options: filteredDialogOptionList,
        list_guid: listGuid || newId,
        name: name?.length > 255 ? name?.slice(0, 255) : name,
        description: description,
        tag_ids: tags
      }
      dispatch(addGlobalList({ ...data, tag_ids: tags?.map((tag) => tag?.pivot?.tag_id || tag?.id) }));
      addDropdown(event, data);
      resetState();
    } else {
      let newDropdownOptions =
        Array.isArray(dropdownList) && dropdownList.length
          ? [...dropdownList]
          : id === "introTextTE"
            ? (Array.isArray(commentData?.introductory_text_dropdowns) ? commentData.introductory_text_dropdowns : [])
            : (Array.isArray(editorData?.dropdownList) ? editorData.dropdownList : []);
      let index = newDropdownOptions?.findIndex((obj) => obj?.dropdown_uuid === selectedDropdown);
      if (index === -1) index = dropdownList?.findIndex((obj) => obj?.isPasted === true);
      const editorInstance = editor?.current?.editor;
      let editorContent = editorInstance?.html?.get();
      const newDialogOptionList = filteredDialogOptionList;
      const optionElements = filteredDialogOptionList?.map((option) => {
        const truncatedOption = option?.length > 40 ? option?.substring(0, 40) + "..." : option;
        const isSelected = newDropdownOptions[index]?.selected_value === option;
        const newOption = option.replace(/"/g, '&quot;')
        return `<option title = "${newOption}" value = "${newOption}" ${isSelected ? "selected" : ""}> ${truncatedOption}</option > `;
      });
      const optionsString = optionElements.join("");
      const selectRegex = new RegExp(`<input[^>]*?id=["']${selectedDropdown}["'][\\s\\S]*?<\\/input>.*?`, "g");
      function replaceOptionsInSelect(selectHtml, newOptionsHtml) {
        const optionsRegex = /(<select[^>]*>)[\s\S]*?(<\/select>)/;
        return selectHtml.replace(optionsRegex, `$1${newOptionsHtml}$2`);
      }
      const newOptionsHtml = `${optionsString}`;
      const replacedContent = editorContent?.replace(selectRegex, (match) => replaceOptionsInSelect(match, newOptionsHtml));
      editorInstance.html.set(replacedContent);
      if (index === -1) {
        newDropdownOptions.push({
          dropdown_uuid: selectedDropdown,
          selected_value: "",
          dropdowns_values: newDialogOptionList?.length === 0 ? [] : newDialogOptionList
        });
      } else {
        newDropdownOptions[index] = {
          ...newDropdownOptions[index],
          dropdowns_values: newDialogOptionList || [],
        };
      }
      const list = newDropdownOptions[index]?.dropdowns_values || [];
      dropdownOptionListRef.current = list;
      updateDropdownContent(newDropdownOptions, editorContent, newDialogOptionList);
      setState(p => ({
        ...p,
        newOption: "",
        textfield: false,
        editedOption: null,
        open: false,
        dialogOptionList: filteredDialogOptionList,
        dropdownList: newDropdownOptions,
        summaryOptionList: id === "commentSummary" ? newDialogOptionList : [],
        listId: null,
        listGuid: null
      }));
    }
  };

  const openHelpDialog = () => {
    setState((prevState) => ({ ...prevState, openHelp: !openHelp }));
    setShowAIModal(!showAIModal);
  };

  Froalaeditor.DefineIcon("aiHelper", { SRC: BulbIcon, ALT: "Image button", height: 50, width: "50px", template: "image" });
  Froalaeditor.RegisterCommand("aiHelper", {
    title: "AI helper",
    focus: false,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      openHelpDialog();
    },
  });

  const toolbarButtonsConfig = {
    moreText: { buttons: ["bold", "italic", "underline", "fontFamily", "fontSize", "textColor", "backgroundColor", "alignLeft", "alignCenter", "alignRight"], align: "left", buttonsVisible: 3 },
    moreRich: { buttons: ["insertLink", "emoticons", "specialCharacters", "fontAwesome", "formatOLSimple", "formatUL", "outdent", "indent"], align: "left", buttonsVisible: 0 },
    moreMisc: { buttons: ["undo", "redo"], align: "right", buttonsVisible: 2 },
  };

  if (showAI) {
    toolbarButtonsConfig.aiHelper = { buttons: ["aiHelper"], align: "left" };
  }

  const setEditorData = (data, type) => {
    const editorInstance = editor?.current?.editor;
    if (!editorInstance) return;
    editorInstance.undo.reset();
    const parser = new DOMParser();
    const document = parser.parseFromString(editorInstance?.html?.get(), "text/html");
    document.querySelectorAll("span").forEach((span) => {
      const hasSelect = span.querySelector("select");
      const hasButton = span.querySelector("button");
      const otherContent = span.cloneNode(true);
      otherContent.querySelectorAll("select, button, input").forEach((child) => child.remove());
      if (otherContent.innerHTML.trim()) {
        const pTag = document.createElement("p");
        pTag.innerHTML = otherContent.innerHTML;
        span.parentNode.insertBefore(pTag, span.nextSibling);
      }
      if (!hasSelect?.id || !hasButton?.id) {
        hasSelect?.remove();
        hasButton?.remove();
        span.remove();
      }
    });
    document.querySelectorAll("select:not([id]), select[id='isPasted']").forEach((select) => {
      let nextSibling = select.nextElementSibling;
      if (!select?.id) select.remove();
      while (nextSibling && nextSibling.nodeType === 1) {
        if (nextSibling?.tagName.toLowerCase() === 'button') {
          nextSibling.remove();
          break;
        }
        nextSibling = nextSibling.nextElementSibling;
      }
    });
    document.querySelectorAll("p, div, span").forEach((el) => {
      if (!el.textContent.trim()) {
        el.remove();
      }
    });
    const pastedElements = document?.querySelectorAll(`[id^="isPasted"], [id^="pasted/"], #isPasted`);
    if (type === "cancel") {
      if (pastedElements?.length > 0) {
        const pastedDoc = parser.parseFromString(data, "text/html");
        pastedElements.forEach((element) => {
          if (element?.tagName === "BR" || element?.tagName === "P") {
            function findNextSpan(node) {
              while (node) {
                if (node?.tagName === "SPAN" || node?.tagName === "SELECT") return node;
                if (node?.tagName === "P") {
                  const nestedSpan = node?.querySelector("span");
                  if (nestedSpan) return nestedSpan;
                  const nestedSelect = node?.querySelector("select");
                  if (nestedSelect) return nestedSelect;
                }
                node = node.nextElementSibling;
              }
              return null;
            }
            const targetSpan = findNextSpan(element.nextElementSibling);
            if (targetSpan?.tagName === "SPAN") {
              const selectElement = targetSpan?.querySelector("select");
              if (selectElement) {
                selectElement.remove();
              }
            } else if (targetSpan?.tagName === "SELECT") {
              targetSpan.remove();
            }
          }
        })
        pastedDoc.querySelectorAll("select:not([id])").forEach((select) => {
          let nextSibling = select.nextElementSibling;
          if (!select?.id) select.remove();
          while (nextSibling && nextSibling.nodeType === 1) {
            if (nextSibling?.tagName.toLowerCase() === 'button') {
              nextSibling.remove();
              break;
            }
            nextSibling = nextSibling.nextElementSibling;
          }
        });
        pastedDoc.querySelectorAll("button:not([id])").forEach((button) => {
          if (!button?.id) button.remove();
        });
        onChange(id, pastedDoc.body.innerHTML);
        editorInstance?.html?.set(pastedDoc.body.innerHTML);
      } else {
        const newDoc = parser.parseFromString(data, "text/html");
        onChange(id, newDoc.body.innerHTML);
        editorInstance?.html?.set(newDoc.body.innerHTML);
      }
    } else {
      if (pastedElements?.length > 0) {
        pastedElements.forEach((element) => {
          const textContent = element.textContent.trim();
          if (textContent) {
            const textNode = document.createTextNode(textContent);
            element.parentNode.replaceChild(textNode, element);
          } else {
            element.remove();
          }
        });
      }
      onChange(id, document.body.innerHTML);
      editorInstance?.html?.set(document.body.innerHTML);
    }
  };

  const handleCloseRemoveDropdown = () => {
    setEditorData(editorData?.innerHTML, "cancel");
    setState((prevState) => ({ ...prevState, openRemoveDropdown: false }));
  };

  const handleSubmitRemoveDropdown = () => {
    const editorInstance = editor?.current?.editor;
    if (!editorInstance) return;
    const copiedData = state.openRemoveDropdown;
    if (!copiedData) return;
    setEditorData(null, "paste");
    editorInstance.html.insert(copiedData);
    setState((prevState) => ({ ...prevState, openRemoveDropdown: false }));
  };

  document.addEventListener("click", function (event) {
    if (event.target.id.startsWith("dropdownIcon_")) {
      let dropdownId = event.target.id.replace("dropdownIcon_", "");
      window.openDropdown(`dropdown_${dropdownId}`, event);
    }
  });

  const handleLinkValidation = function (link, text, attrs) {
    const urlPattern = /^(https?:\/\/)([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
    const testResult = urlPattern.test(link);
    if (testResult) {
      return true
    } else {
      toast.error("Please enter a valid URL.")
      return false;
    }
  };
  const handleOutsideClick = async () => {
    const editorInstance = editor.current?.editor;
    if (!editorInstance) return;
    const updatedDropdownList = persistDynamicInputValues(
      editorInstance,
      getDropdownListSource()
    );
    const editorContent = editorInstance.html.get();
    onChange?.(id, editorContent);
    syncEditorStateWithDropdowns(editorContent, updatedDropdownList);
    if (onBlur && (storeData?.editorListner || id === "introTextTE")) {
      await onBlur(id, editorContent);
      syncChangedDropdownsOnBlur(editorContent, updatedDropdownList);
      setState((prevState) => ({ ...prevState, isFocused: false }));
    }
  };

  const saveEditorSelection = () => {
    if (state.open) return;
    const editorRoot = editor.current?.editor?.$el?.get(0);
    if (!editorRoot) return;
    const activeEl = document.activeElement;
    if (activeEl && !editorRoot.contains(activeEl) && activeEl !== editorRoot) {
      return;
    }
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
      const range = sel.getRangeAt(0);
      if (editorRoot.contains(range.commonAncestorContainer)) {
        if (
          range.commonAncestorContainer === editorRoot &&
          range.startOffset === 0 &&
          editorRoot.childNodes.length > 0 &&
          savedRangeRef.current
        ) {
          return;
        }
        savedRangeRef.current = range.cloneRange();
      }
    }
  };

  const preserveEditorSelectionForList = (e) => {
    e.preventDefault();
    const active = document.activeElement;
    if (active?.closest?.(".froala-dynamic-input-wrapper")) {
      lastFocusedDynamicWrapperRef.current = active.closest(".froala-dynamic-input-wrapper");
    }
    if (active?.closest?.('span[id^="dropdown_"]')) {
      lastFocusedDropdownRef.current = active.closest('span[id^="dropdown_"]');
    }
    saveEditorSelection();
  };

  const handleEnterCaretFixRef = useRef(() => { });

  const bindEnterCaretFixHandler = (editorRoot) => {
    if (!editorRoot) return;
    const editableRoot = editorRoot.querySelector('.fr-element') || editorRoot;
    if (editableRoot.dataset.enterCaretFixBound === 'true') return;
    editableRoot.dataset.enterCaretFixBound = 'true';
    editableRoot.addEventListener(
      'keydown',
      (event) => handleEnterCaretFixRef.current(event),
      true
    );
  };

  handleEnterCaretFixRef.current = (event) => {
    if (event.key !== 'Enter' || event.shiftKey) return;

    const editorInstance = editor.current?.editor;
    const editorRoot = editorInstance?.$el?.get(0);
    const editableRoot = editorRoot?.querySelector('.fr-element') || editorRoot;
    if (!editableRoot) return;

    const selection = window.getSelection();
    if (!selection?.rangeCount) return;

    const beforeAnchorNode = selection.anchorNode;
    const beforeAnchorOffset = selection.anchorOffset;
    if (!beforeAnchorNode) return;

    const anchorEl =
      beforeAnchorNode.nodeType === Node.ELEMENT_NODE ? beforeAnchorNode : beforeAnchorNode.parentElement;
    const originBlock = anchorEl?.closest('p, li, div, h1, h2, h3, h4, h5, h6, blockquote') || editableRoot;
    const originNextSiblingBefore = originBlock?.nextElementSibling || null;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const sel = window.getSelection();
        if (!sel?.rangeCount) return;

        const stillStuck =
          sel.anchorNode === beforeAnchorNode && sel.anchorOffset === beforeAnchorOffset;
        if (!stillStuck) return;

        const newLine =
          originBlock?.parentNode && originBlock.nextElementSibling !== originNextSiblingBefore
            ? originBlock.nextElementSibling
            : null;
        if (!newLine || !editableRoot.contains(newLine)) return;

        editableRoot.focus();
        const fixRange = document.createRange();
        fixRange.selectNodeContents(newLine);
        fixRange.collapse(true);
        sel.removeAllRanges();
        sel.addRange(fixRange);

        const activeEditor = editor.current?.editor;
        if (activeEditor?.selection?.setRange) {
          try { activeEditor.selection.setRange(fixRange); } catch (e) { /* best-effort sync */ }
        }
      });
    });
  };

  const handleButtonClicks = (e, type) => {
    const grandParent = e.target.parentElement.parentElement;
    const grandParentPrevSibling = grandParent.previousElementSibling;
    if (setActiveEditorId) setActiveEditorId(grandParentPrevSibling?.id || id);
    saveEditorSelection();
    setAnchorEl(null);
    setCurrentInputId(null);
    setState((prevState) => ({ ...prevState, open: type, dialogOptionList: [] }))
  }

  return (
    <div id={id} style={{ width: "100%" }}>
      {!open ? <Popper open={Boolean(anchorEl && document.body.contains(anchorEl))}
        anchorEl={document.body.contains(anchorEl) ? anchorEl : null}
        placement="bottom-end"
        sx={{
          zIndex: 10000,
          '&[data-popper-placement^="bottom"]': { marginTop: '1px !important' },
          '&[data-popper-placement^="top"]': { marginBottom: '1px !important' }
        }}
        modifiers={[{ name: 'flip', options: { fallbackPlacements: ['bottom-end', 'top-start', 'top-end'] } },
        { name: 'preventOverflow', options: { mainAxis: true, altAxis: true } },
        ]}
        id={`popper-${id}`}
      >
         <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Paper key={`dropdown-${id}-${currentInputId?.replace("dropdown_", "")}`}
            style={{ width: "242px", minHeight: "20px", height: "auto", maxHeight: "200px", overflow: isDropdownLoading ? "hidden" : "auto", textAlign: isDropdownLoading ? "center" : null, textOverflow: "ellipsis" }}>
            {isDropdownLoading ? <CircularProgress /> : dialogOptionList?.length === 0 ? <MenuItem sx={{ fontSize: "14px", padding: "12px 4px 12px 8px", fontFamily: "Open Sans", letterSpacing: 0 }}>{"     "}</MenuItem> :
              dialogOptionList?.map((e, index) => (
                <MenuItem key={index} sx={{
                  fontSize: "14px",
                  padding: "5px 4px 5px 8px",
                  fontFamily: "Open Sans",
                  letterSpacing: 0,
                  color: "#3B3B3B",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  maxWidth: "241px",
                  display: "block",
                  minHeight: "auto"
                }} onClick={() => handleSelect(e)}>{String(e)}</MenuItem>
              ))
            }
          </Paper>
        </ClickAwayListener>
      </Popper> : null}
      <div id={id} className="editor-class" style={{ width: "100%", color: "#fff", isolation: "isolate" }}>
        <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={() => isFocused && handleOutsideClick()}>
          <FroalaEditor
            id={id}
            ref={editor}
            value={editorData}
            onModelChange={handleModelChange}
            config={{
              key: "zEG4iE3C7A8A4C4A3A4aIVLEABVAYFKc2Cb1MYGH1g1NYVMiG5G4E3A2A1C8C6D4D4C4==",
              spellCheck: true,
              imagePaste: false,
              placeholderText: "",
              htmlUntouched: true,
              emptyBlocks: false,
              charCounterCount: false,
              quickInsertEnabled: false,
              htmlAllowEmpty: true,
              paragraphFormat: { N: 'Normal' },
              pastePlain: true,
              pasteDeniedAttrs: ['style', 'class', 'id'],
              pasteDeniedTags: ['style'],
              wordPasteModal: false,
              enter: FroalaEditor.ENTER_P,
              htmlWhitespace: true,
              keepFormatOnDelete: true,
              toolbarButtons: toolbarButtonsConfig,
              htmlAllowedTags: ['input', 'span', 'button', 'select', 'option', 'strong', 'u', 'i', 'em', 'a', 'br', 'p', 'div', 'li', 'ol', 'ul', 'blockquote'],
              linkAutoPrefix: "https://",
              linkAlwaysBlank: true,
              pluginsEnabled: ["wordPaste", "spellChecker", "codeBeautifier", "fontFamily", "fontSize", "colors", "align", "lists"],
              ...froalaConfig,
              events: {
                ...(froalaConfig?.events || {}),
                'link.beforeInsert': handleLinkValidation,
                "paste.before": handlePasteBefore,
                'focus': function () {
                  froalaConfig?.events?.['focus']?.call(this);
                  if (onFocusEditor) onFocusEditor();
                },
                'blur': function () {
                  froalaConfig?.events?.['blur']?.call(this);
                  saveEditorSelection();
                },
                'keyup': function () {
                  froalaConfig?.events?.['keyup']?.call(this);
                  saveEditorSelection();
                },
                'mouseup': function () {
                  froalaConfig?.events?.['mouseup']?.call(this);
                  saveEditorSelection();
                },
                'keydown': function (e) {
                  froalaConfig?.events?.['keydown']?.call(this, e);
                },
                'initialized': function () {
                  froalaConfig?.events?.['initialized']?.call(this);
                  ensureDynamicInputObserver(this.$el?.get(0));
                  bindDynamicInputRemovalKeydownHandler(this.$el?.get(0));
                  bindEnterCaretFixHandler(this.$el?.get(0));
                },
              },
            }
            }
          />
        </ClickAwayListener>
        {(location.pathname.includes("templates") && ((isNarrativeTemplate && id === "introTextTE") || (id === "commentText" || id === "commentSummary" || id === "nonNarrativeComment"))) ? (
          <Grid display={"flex"} className="add-dropdown-box">
            <Button
              className="add-dropdown-typo"
              id="add-input"
              onMouseDown={preserveEditorSelectionForList}
              onClick={(event) => addInput(event)}
              disableRipple
              startIcon={<TextFieldsIcon className="add-dropdown-circle" />}
            >
              Add input
            </Button>
            <>
              <Button
                className="add-dropdown-typo"
                id="add-dropdown"
                onMouseDown={preserveEditorSelectionForList}
                onClick={(e) => handleButtonClicks(e, "global_lists")}
                disableRipple
                startIcon={< MenuBookIcon className="add-dropdown-circle" />}
              >
                Global lists
              </Button>
              <Button
                className="add-dropdown-typo"
                id="add-dropdown"
                onMouseDown={preserveEditorSelectionForList}
                onClick={(e) => handleButtonClicks(e, "new_list")}
                disableRipple
                startIcon={<AddCircleOutlineOutlinedIcon className="add-dropdown-circle" />}
              >
                New list
              </Button>
            </>
          </Grid>
        ) : (id === "" || id === "commentText" || id === "commentSummary" || (id === "nonNarrativeComment" && AllCategoryList?.template?.is_hip_template)) ? (
          <Grid display={"flex"} className="add-dropdown-box">
            <Button
              className="add-dropdown-typo"
              id="add-input"
              onMouseDown={preserveEditorSelectionForList}
              onClick={(event) => addInput(event)}
              disableRipple
              startIcon={<TextFieldsIcon className="add-dropdown-circle" />}
            >
              Add input
            </Button>
            <>
              <Button
                className="add-dropdown-typo"
                id="add-dropdown"
                onMouseDown={preserveEditorSelectionForList}
                onClick={(e) => handleButtonClicks(e, "global_lists")}
                disableRipple
                startIcon={<MenuBookIcon className="add-dropdown-circle" />}
              >
                Global lists
              </Button>
              <Button
                className="add-dropdown-typo"
                id="add-dropdown"
                onMouseDown={preserveEditorSelectionForList}
                onClick={(e) => handleButtonClicks(e, "new_list")}
                disableRipple
                startIcon={<AddCircleOutlineOutlinedIcon className="add-dropdown-circle" />}
              >
                New list
              </Button>
            </>
          </Grid>
        ) : null}
      </div>
      <EditOptionsDialog handleDeleteDropdown={handleDeleteDropdown}
        dialogRef={dialogRef} id={id} state={state} setState={setState} handleSave={handleSave}
        filterTagList={filterTagList} addDropdown={addDropdown} categoryTags={categoryTags} newOpen={newOpen}
        canSave={dialogOptionList?.some((option) => option && option.trim().length > 0) && (!saveToGlobalLists || (saveToGlobalLists && name && name?.trim()?.length > 0))}
      />
      {openRemoveDropdown && <CopySummaryModal
        dialogRef={dialogRef}
        open={openRemoveDropdown}
        handleClose={handleCloseRemoveDropdown}
        handleSubmit={handleSubmitRemoveDropdown}
        submitButtonTitle={"Paste Without Dropdown"}
        dialogTitle={"Dropdown Won't Be Included"}
        dialogContentText={"Dropdowns cannot be copied and pasted. If you continue, only the text will be pasted without the dropdown."}
      />}
    </div >
  );
};

export default FroalaEditorComponent;
